// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * ChatView: the one chat surface (Open Search, Focused Study multi/single),
 * set like a printed interview (BRAND_SPEC §11.1). No bubbles: a person's
 * words in Newsreader, AI Rob's in Inter, a label over every turn. Single
 * column, 20 px sides, 680 px at most; every control at least 44 px.
 */

.chat-view {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  height: 100%;
  position: relative;
  color: var(--brand-fg);
  background: var(--brand-bg);
}

.cv-column {
  width: 100%;
  max-width: calc(var(--column-chat) + 40px);
  margin: 0 auto;
  padding: 0 20px;
}

/* A mode header (Focused Study) slides up by its measured height while a
   conversation is read on a phone; .shell-content clips it on the way out.
   ChatView sets --cv-header-h and the .tucked class. */
.cv-header-slot {
  flex-shrink: 0;
  transition:
    margin-top var(--dur-base) var(--ease-out),
    opacity var(--dur-fast) var(--ease-out),
    visibility 0s linear 0s;
}

.chat-view.tucked .cv-header-slot {
  margin-top: calc(-1 * var(--cv-header-h, 56px));
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition:
    margin-top var(--dur-base) var(--ease-out),
    opacity var(--dur-fast) var(--ease-out),
    visibility 0s linear var(--dur-base);
}

/* ---- the conversation -------------------------------------------------- */

.cv-messages-wrap {
  flex: 1;
  min-height: 0;
  position: relative;
  display: flex;
  flex-direction: column;
}

.cv-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  padding: 18px 0 12px;
  scroll-padding-bottom: 24px;
}

.cv-end { height: 1px; }

/* Room after a short answer so its question can sit at the top of the
   screen; ChatView sizes it (0 whenever nothing is parked). */
.cv-tail-space { height: 0; pointer-events: none; }

.cv-msg {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

/* Labels: Inter 600 13 px, sentence case, --brand-muted (§6.4). */
.cv-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.8125rem;
  line-height: 1.35;
  font-weight: 600;
  color: var(--brand-muted);
}

.cv-label .apr-mark {
  flex: none;
  display: block;
  color: var(--brand-fg);
}

/* A person's words: the serif (§6.2). The first question is the heading. */
.cv-msg.user {
  margin: 30px 0 14px;
}

.cv-column > .cv-msg.user:first-of-type,
.cv-scroll .cv-msg.user:first-child {
  margin-top: 0;
}

.cv-question {
  margin: 8px 0 0;
  font-family: var(--font-serif);
  font-weight: 440;
  color: var(--brand-fg);
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  text-wrap: balance;
}

.cv-question.size-lead {
  font-size: 1.9375rem;
  line-height: 1.1;
  letter-spacing: -0.012em;
  font-variation-settings: "opsz" 36;
}

.cv-question.size-follow {
  font-size: 1.5rem;
  line-height: 1.17;
  letter-spacing: -0.012em;
  font-variation-settings: "opsz" 36;
}

.cv-question.size-long {
  font-size: 1.1875rem;
  line-height: 1.5;
  font-weight: 400;
  font-variation-settings: "opsz" 18;
  text-wrap: pretty;
}

/* Arriving from an ad: the question parks as the heading (§9.5), transform
   only. The children move, not the turn itself, so the view parks on the
   turn's resting place. */
.cv-msg.user.landing > * {
  animation: cvPark var(--dur-base) var(--ease-out);
}

@keyframes cvPark {
  from { transform: translateY(28px); }
  to { transform: none; }
}

.cv-arrival {
  margin: 10px 0 0;
  font-size: 0.875rem;
  line-height: 1.45;
  color: var(--brand-muted);
}

.cv-arrival-edit {
  display: inline-block;
  min-height: 24px;
  padding: 0;
  font-weight: 600;
  color: var(--brand-fg);
  text-decoration-line: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 0.2em;
}

/* AI Rob's answers: Inter 400 17/27, --brand-fg-read, 66ch (§6.4). */
.cv-msg.assistant {
  margin: 24px 0 26px;
}

.cv-msg.user + .cv-msg.assistant,
.cv-msg.user + .cv-msg.streaming {
  margin-top: 22px;
}

.cv-answer {
  margin-top: 8px;
}

/* A finished answer replaces its streaming twin in place: no second entrance. */
.cv-msg.settled { animation: none; }

/* Streamed words fade in, 200 ms, opacity only (§9.5). ChatView's
   inkFreshText sets a negative delay so each word's fade survives the next
   re-render. */
.cv-fresh { animation: cvInk var(--stream-word-fade) ease-out both; }

@keyframes cvInk {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* AI Rob's writing caret: grey, 2 px, solid, at the insertion point while the
   answer streams, gone when it ends (§4, §9.2). */
.cv-caret-ai {
  display: inline-block;
  width: 2px;
  height: 1.15em;
  margin-left: 2px;
  vertical-align: -0.2em;
  background: var(--brand-caret-ai);
}

.cv-msg.streaming .cv-markdown > :last-child:not(ul):not(ol)::after,
.cv-msg.streaming .cv-markdown > :last-child > li:last-child::after {
  content: '';
  display: inline-block;
  width: 2px;
  height: 1.15em;
  margin-left: 2px;
  vertical-align: -0.2em;
  background: var(--brand-caret-ai);
}

.cv-markdown {
  max-width: var(--measure);
  font-size: 1.0625rem;
  line-height: 1.6;
  color: var(--brand-fg-read);
  overflow-wrap: break-word;
  text-wrap: pretty;
}

.cv-markdown p { margin: 0 0 12px; color: inherit; }
.cv-markdown p:last-child { margin-bottom: 0; }
.cv-markdown h1,
.cv-markdown h2,
.cv-markdown h3 {
  margin: 20px 0 8px;
  font-family: var(--font-sans);
  font-size: 1.125rem;
  line-height: 1.35;
  font-weight: 600;
  color: var(--brand-fg);
}
.cv-markdown h1:first-child,
.cv-markdown h2:first-child,
.cv-markdown h3:first-child { margin-top: 0; }
.cv-markdown ul,
.cv-markdown ol { margin: 4px 0 14px; padding-left: 1.3em; }
.cv-markdown li { margin: 6px 0; padding-left: 2px; }
.cv-markdown li::marker { color: var(--brand-muted); }
.cv-markdown li p { margin: 0; }
.cv-markdown strong { color: var(--brand-fg); font-weight: 600; }
/* No italics in running text (BDA, §6.5): emphasis is the brighter ink. */
.cv-markdown em { font-style: normal; color: var(--brand-fg); }
.cv-markdown hr { border: 0; border-top: 1px solid var(--brand-line); margin: 18px 0; }
.cv-markdown code {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.88em;
  padding: 0.1em 0.35em;
  border-radius: var(--radius-sm);
  background: var(--brand-surface-2);
  color: var(--brand-fg);
}
.cv-markdown a {
  color: var(--brand-fg);
  text-decoration-line: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 0.2em;
}
.cv-markdown a:hover { text-decoration-thickness: 2px; }

/* A quoted passage from a live answer: the sans, with a quiet rule. Serif
   is only for words the server or Rob's approval has verified (§6.2). */
.cv-markdown blockquote {
  margin: 14px 0;
  padding: 2px 0 2px 14px;
  border-left: 2px solid var(--brand-line-control);
  color: var(--brand-fg-read);
}

/* Rob's verbatim words (a Rob-approved answer): Newsreader roman, opsz 18,
   18/26, white, the 2 px rule, curly quotes in the text itself. */
.cv-markdown blockquote.cv-verbatim,
.cv-markdown .cv-verbatim {
  font-family: var(--font-serif);
  font-weight: 400;
  font-variation-settings: "opsz" 18;
  font-size: 1.125rem;
  line-height: 1.45;
  color: var(--brand-fg);
}

/* Citations (utils/sermonTimestampLinks.js): the name stays in the sentence,
   in the sentence's own style; a small number after it is the link. */
.cv-markdown .cv-cite-name { font-style: normal; }
.cv-markdown .cv-cite {
  font-family: var(--font-sans);
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  line-height: 0; /* never pushes its line away from the next */
  vertical-align: 0.5em;
  margin-left: 0.15em;
}
/* Numbers back to back read "¹,²". Which ones touch is decided where they are
   placed (cv-cite-more): a sibling selector cannot see the sentence between
   two numbers in one paragraph, and would put a comma there too. */
.cv-markdown .cv-cite-more::before { content: ','; color: var(--brand-muted); }
/* The padding gives the hover wash room; the matching negative margin keeps
   the number against its word and the comma or period after it. */
.cv-markdown .cv-cite a,
.cv-markdown .cv-cite .cv-cite-num {
  padding: 0.25em 0.2em;
  margin: 0 -0.2em;
  border-radius: 4px;
  color: var(--brand-fg);
  text-decoration-line: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 2px;
}
.cv-markdown .cv-cite .cv-cite-num { color: var(--brand-muted); text-decoration: none; cursor: default; }
.cv-markdown .cv-cite a:hover { background: var(--brand-surface-2); }
/* What a screen reader says for a number that links nowhere (the book). */
.cv-markdown .cv-cite-sr {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  white-space: nowrap;
  user-select: none;
}

/* Fingers: a superscript stays small but takes a finger-sized tap (24 x 24
   or more, WCAG 2.2 SC 2.5.8), and each source row fills its width. */
@media (hover: none) {
  .cv-markdown .cv-cite a { position: relative; }
  .cv-markdown .cv-cite a::after { content: ''; position: absolute; inset: -12px -9px; }
  /* Back to back, each number keeps its own side of the comma: the later one
     no longer reaches left over the earlier, nor the earlier right over it. */
  .cv-markdown .cv-cite-more a::after { left: 0; }
  .cv-markdown .cv-cite:has(+ .cv-cite-more) a::after { right: 0; }
}

/* Pointers: the same 24 px target, as padding around the number. */
@media (hover: hover) {
  .cv-markdown .cv-cite a {
    display: inline-block;
    min-width: 1.2em;
    padding: 0.5em 0.3em;
    margin: -0.5em -0.3em;
    text-align: center;
  }
}

/* Bible references (utils/scripture.js): a tap opens the passage. At rest
   one looks exactly like the words around it, its colour, face and weight
   inherited, in bold too (§6.5's one exception to "links keep their
   underline"); a brief wash while pressed, the hand and the link's line
   under a mouse, the global ring for the keyboard, no transitions. It wraps
   like the words around it, so no size of text pushes the answer sideways;
   a tap on either line opens it. data-scripture="hint" (scriptureLinks 2)
   adds a faint dotted line. */
.cv-markdown .cv-scripture { cursor: pointer; border-radius: 3px; -webkit-tap-highlight-color: transparent; }
.cv-markdown .cv-scripture:active { background: var(--brand-surface-2); }
.cv-markdown .cv-scripture:focus-visible { color: var(--brand-fg); }
.chat-view[data-scripture="hint"] .cv-markdown .cv-scripture { text-decoration: underline dotted 1px; text-underline-offset: 0.25em; text-decoration-color: var(--brand-line-control); }
@media (hover: hover) { .chat-view .cv-markdown .cv-scripture:hover { color: var(--brand-fg); text-decoration: underline solid 1px; text-decoration-color: currentColor; text-underline-offset: 0.2em; } }

/* ---- sources: "From Rob's sermons" (§11.1) ------------------------------
   The cited list (renderSourceRows) and, for an answer that cites nothing,
   the sermons it drew on (.cv-sources). Each row is one link. */
.cv-cites,
.cv-sources {
  margin: 0 0 4px;
  padding-top: 14px;
  border-top: 1px solid var(--brand-line);
  max-width: var(--measure);
}

.cv-cites-label,
.cv-sources-label {
  display: block;
  margin-bottom: 2px;
  font-size: 0.8125rem;
  line-height: 1.35;
  font-weight: 600;
  color: var(--brand-muted);
}

.cv-cites-list,
.cv-src-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.cv-src {
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr) 40px;
  align-items: center;
  gap: 12px;
  min-height: 60px;
  padding: 10px 0;
  border-bottom: 1px solid var(--brand-line);
  color: var(--brand-fg);
  text-decoration: none;
  border-radius: 2px;
  transition: outline-color var(--dur-fast) var(--ease-out);
}

.cv-src-list .cv-src {
  grid-template-columns: 24px minmax(0, 1fr);
}

a.cv-src:hover { text-decoration: none; }
a.cv-src:hover .cv-src-title { text-decoration: underline; text-underline-offset: 0.2em; }
a.cv-src:hover .cv-src-go { background: var(--brand-surface-2); }

/* A citation tap lands here: a 2 px white outline for 1.2 s (§9.5). */
.cv-src.is-flash {
  outline: 2px solid var(--brand-fg);
  outline-offset: 2px;
}

.cv-src-n {
  display: grid;
  place-items: center;
  width: 24px;
  height: 24px;
  border: 1px solid var(--brand-line-control);
  border-radius: var(--radius-sm);
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1;
  font-variant-numeric: tabular-nums;
  color: var(--brand-fg);
}

.cv-src-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.cv-src-title {
  font-size: 0.9375rem;
  line-height: 1.3;
  font-weight: 500;
  color: var(--brand-fg);
  overflow-wrap: anywhere;
}

.cv-src-meta {
  margin-top: 2px;
  font-size: 0.8125rem;
  line-height: 1.4;
  color: var(--brand-muted);
  font-variant-numeric: tabular-nums;
}

.cv-src-go {
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid var(--brand-line-control);
  color: var(--brand-muted);
}

.cv-src.is-static .cv-src-go { border-color: transparent; }

/* ---- actions under an answer (quiet, 44 px) ------------------------------ */

.cv-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin: 16px 0 18px;
}

.cv-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 44px;
  min-height: 44px;
  padding: 0 12px;
  border-radius: var(--radius-md);
  border: 1px solid var(--brand-line-control);
  background: transparent;
  color: var(--brand-fg);
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
}

.cv-action small {
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--brand-muted);
}

.cv-action:hover:not(:disabled) { background: var(--brand-surface-2); }
.cv-action:disabled { color: var(--brand-line-control); cursor: default; }
.cv-action.icon { width: 44px; padding: 0; }
/* "Fix in Zed" (owners and admins only) is a link to the portal, drawn as the buttons beside it. */
a.cv-action { text-decoration: none; box-sizing: border-box; }

/* Chosen (a thumb, "Sent to Rob", playing): a 2 px white edge, never a fill. */
.cv-action.chosen,
.cv-action.playing,
.cv-action.loading {
  border-color: var(--brand-fg);
  box-shadow: inset 0 0 0 1px var(--brand-fg);
}

/* First Answer's More (ChatParts MoreAnswer): under a short first answer and
   before its actions, the one next step it offers. The brand's line button
   (.apr-btn, 48 px, a 2 px edge in the text colour, never a fill). */
.cv-more-answer-row { margin: 16px 0 0; }
.cv-more-answer { min-width: 132px; padding: 0 16px 0 20px; }
.cv-more-answer-row + .cv-actions { margin-top: 12px; }

/* "Fast answer · 6.1 s · Go deeper": a quiet line under the actions. */
.cv-answer-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: -10px 0 18px 2px;
  font-size: 0.8125rem;
  line-height: 1.4;
  color: var(--brand-subtle);
  font-variant-numeric: tabular-nums;
}

.cv-answer-meta > span[aria-hidden] {
  white-space: pre;
}

.cv-deeper {
  min-height: 44px;
  padding: 0;
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--brand-fg);
  text-decoration-line: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 0.2em;
}

.cv-deeper:disabled { color: var(--brand-line-control); }

/* Notes from the app itself (stopped, cut off, the 3-hour reminder): not an
   AI turn, so no label. */
.cv-note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 0;
  max-width: var(--measure);
  font-size: 0.9375rem;
  line-height: 1.5;
  color: var(--brand-muted);
}

.cv-note .apr-icon { margin-top: 3px; }
.cv-msg.local { margin: 8px 0 22px; }
.cv-msg.assistant > .cv-note { margin-top: 12px; }

/* The answer in flight: its running time, quietly. */
.cv-stream-footer {
  display: flex;
  gap: 10px;
  align-items: baseline;
  margin-top: 10px;
  font-size: 0.8125rem;
  color: var(--brand-subtle);
  font-variant-numeric: tabular-nums;
}

.cv-timer { color: var(--brand-muted); font-weight: 500; }

/* ---- thinking (§9.5): one status line and the grey caret, solid ---------- */

.thinking-card {
  margin-top: 8px;
  font-size: 0.8125rem;
  line-height: 1.45;
}

.thinking-status {
  margin: 0;
  font-weight: 500;
  color: var(--brand-muted);
}

.thinking-steps {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 6px 0 0;
  padding: 0;
  color: var(--brand-subtle);
  font-weight: 500;
}

.thinking-steps li + li::before {
  content: '·';
  margin: 0 6px;
  color: var(--brand-subtle);
}

.thinking-steps li.done { color: var(--brand-muted); }
.thinking-steps li.current { color: var(--brand-fg); font-weight: 600; }

.thinking-meta,
.thinking-sub,
.thinking-found,
.thinking-thought {
  margin: 4px 0 0;
  color: var(--brand-subtle);
  font-variant-numeric: tabular-nums;
}

.thinking-elapsed { color: var(--brand-muted); font-weight: 500; }
.thinking-sub { color: var(--brand-muted); }
.thinking-found { color: var(--brand-muted); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.thinking-thought { max-height: 4.4em; overflow: hidden; }

/* ---- the welcome screen (no campaign) ------------------------------------ */

.cv-welcome {
  margin: 6vh 0 24px;
}

.cv-welcome-title {
  position: relative;
  margin: 0;
  font-family: var(--font-serif);
  font-weight: 440;
  /* A size up (Alexi, Oct 17): about 36 px on a phone, up to 44 px on a computer. */
  font-size: clamp(2.25rem, 1.95rem + 1.4vw, 2.75rem);
  line-height: 1.1;
  letter-spacing: -0.012em;
  font-variation-settings: "opsz" 36;
  color: var(--brand-fg);
}

/* "Ask anything." typing (WelcomeTitle, §9.1): the words stay in place,
   transparent, under an aria-hidden copy that shows them a character at a
   time with the caret after them. The caret is a point on the baseline that
   draws the bar (so it takes no room, not even in the line's height) and the
   rest of the copy is laid out but unseen: the copy lies exactly on the words
   and nothing moves when it goes. The caret is solid while it types. */
.cv-welcome-title.is-typing .cv-title-words { color: transparent; }
.cv-title-typed {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0; /* not \`inset\`: an older phone without it would set the copy beside the words */
  white-space: nowrap;
  pointer-events: none;
}
.cv-title-rest { visibility: hidden; }
.cv-title-caret {
  position: relative;
  display: inline-block;
  width: 0;
  height: 0;
}
.cv-title-caret::after {
  content: '';
  position: absolute;
  left: var(--caret-gap);
  bottom: calc(-1 * var(--caret-drop));
  width: var(--caret-width);
  height: var(--caret-height);
  background: var(--brand-caret);
}
/* High-contrast modes repaint every colour, transparent included: just the words. */
@media (forced-colors: active) {
  .cv-title-typed { display: none; }
}

.cv-welcome-text {
  margin: 12px 0 0;
  max-width: 34em;
  font-size: 1.0625rem;
  line-height: 1.6;
  color: var(--brand-fg-read);
}

/* Starter questions: rows of a person's words, one tap each (§11.1). */
.cv-starters {
  list-style: none;
  margin: 28px 0 0;
  padding: 0;
  border-top: 1px solid var(--brand-line);
}

.cv-starter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  min-height: 60px;
  padding: 14px 2px;
  border-bottom: 1px solid var(--brand-line);
  color: var(--brand-fg);
  font-family: var(--font-serif);
  font-weight: 440;
  font-size: 1.25rem;
  line-height: 1.25;
  font-variation-settings: "opsz" 24;
  text-align: left;
}

.cv-starter .apr-icon { color: var(--brand-muted); }
.cv-starter:hover:not(:disabled) span { text-decoration: underline; text-decoration-thickness: 1px; text-underline-offset: 0.2em; }
.cv-starter:hover:not(:disabled) .apr-icon { color: var(--brand-fg); }
.cv-starter:disabled { color: var(--brand-subtle); cursor: default; }

/*
 * The glimmer (utils/starterGlimmer.js): one row at a time, a band of light
 * runs along its rule, a faint sheen crosses the row, and the arrow brightens
 * and leans toward a tap. Monochrome like everything else (BRAND_SPEC: no
 * hue): the light is the text colour, so it reads in Night and Day. Hovering
 * a row plays it too, on a pointer that can hover. Never with reduced motion.
 */
.cv-starter { position: relative; isolation: isolate; }
.cv-starter::before,
.cv-starter::after {
  content: '';
  position: absolute;
  pointer-events: none;
  opacity: 0;
}
/* The rule's light: a short bright band gliding along the row's bottom line. */
.cv-starter::after {
  left: 0;
  right: 0;
  bottom: -1px;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--brand-fg) 50%, transparent) no-repeat;
  background-size: 38% 100%;
  background-position: -60% 0;
  box-shadow: 0 0 10px 0 color-mix(in srgb, var(--brand-fg) 35%, transparent);
}
/* The row's sheen: a soft diagonal wash of light, barely there. Light on
   Night's black is the text colour; on Day's cream it is white (a dark wash
   there reads as a smudge, not a sheen). */
.cv-starter::before {
  inset: 0 -2px;
  z-index: -1;
  background: linear-gradient(105deg, transparent 30%, var(--cv-sheen-face, color-mix(in srgb, var(--brand-fg) 7%, transparent)) 50%, transparent 70%) no-repeat;
  background-size: 60% 100%;
  background-position: -110% 0;
}
:root[data-theme="day"] { --cv-sheen-face: rgba(255, 255, 255, 0.85); }
.cv-starter.is-glimmer::after { animation: cv-sheen-rule 1.3s cubic-bezier(0.45, 0, 0.2, 1) both; }
.cv-starter.is-glimmer::before { animation: cv-sheen-face 1.3s cubic-bezier(0.45, 0, 0.2, 1) both; }
.cv-starter.is-glimmer .apr-icon { animation: cv-sheen-arrow 1.3s cubic-bezier(0.45, 0, 0.2, 1) both; }
@media (hover: hover) and (pointer: fine) {
  .cv-starter:hover:not(:disabled)::after { animation: cv-sheen-rule 1.1s cubic-bezier(0.45, 0, 0.2, 1) both; }
  .cv-starter:hover:not(:disabled)::before { animation: cv-sheen-face 1.1s cubic-bezier(0.45, 0, 0.2, 1) both; }
}
@keyframes cv-sheen-rule {
  0% { opacity: 0; background-position: -60% 0; }
  14% { opacity: 1; }
  86% { opacity: 1; }
  100% { opacity: 0; background-position: 160% 0; }
}
@keyframes cv-sheen-face {
  0% { opacity: 0; background-position: -110% 0; }
  20% { opacity: 1; }
  80% { opacity: 1; }
  100% { opacity: 0; background-position: 210% 0; }
}
@keyframes cv-sheen-arrow {
  0%, 100% { color: var(--brand-muted); transform: none; }
  45%, 60% { color: var(--brand-fg); transform: translateX(3px); }
}
@media (prefers-reduced-motion: reduce) {
  .cv-starter::before,
  .cv-starter::after,
  .cv-starter.is-glimmer .apr-icon { animation: none !important; }
}

/* "More questions": another four, quietly, under the list. */
.cv-more-starters {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  margin-top: 6px;
  padding: 0 2px;
  color: var(--brand-muted);
  font-family: var(--font-sans);
  font-size: 1.0625rem; /* 17 px: words to read and act on */
  font-weight: 500;
}
.cv-more-starters:hover:not(:disabled) { color: var(--brand-fg); }
.cv-more-starters:hover:not(:disabled) span { text-decoration: underline; text-decoration-thickness: 1px; text-underline-offset: 0.2em; }
.cv-more-starters:active:not(:disabled) .apr-icon { transform: rotate(180deg); transition: transform 0.3s ease; }
.cv-more-starters:disabled { color: var(--brand-subtle); cursor: default; }
@media (prefers-reduced-motion: reduce) { .cv-more-starters .apr-icon { transition: none !important; } }

/* Nothing asked yet (team review, Oct 2026): the welcome, the box, then the
   questions to start with and the fine print, centred together on the
   screen; the whole view scrolls if a short screen can't hold them. The
   first question takes .is-empty away and the box goes back to the bottom. */
.chat-view.is-empty { overflow-y: auto; }
.chat-view.is-empty .cv-messages-wrap { flex: none; margin-top: auto; }
.chat-view.is-empty .cv-scroll { flex: none; overflow: visible; padding-bottom: 0; }
.chat-view.is-empty .cv-end,
.chat-view.is-empty .cv-tail-space { display: none; }
.chat-view.is-empty .cv-welcome { margin: 0 0 22px; text-align: center; }
.chat-view.is-empty .cv-welcome-text { margin-left: auto; margin-right: auto; text-wrap: balance; }
.chat-view.is-empty .cv-composer { padding-top: 0; padding-bottom: 0; }
.chat-view.is-empty .cv-form > .cv-disclaimer { display: none; }
/* The toolbar stays open here; it only folds away while reading. */
.chat-view.is-empty .cv-composer.collapsed .cv-chrome { grid-template-rows: 1fr; opacity: 1; }
.chat-view.is-empty .cv-composer.collapsed .cv-chrome-inner { visibility: visible; transition-delay: 0s; }
.cv-below {
  flex: none;
  margin-bottom: auto;
  padding-bottom: calc(16px + env(safe-area-inset-bottom, 0px));
}
.cv-below .cv-starters { margin-top: 18px; }
.cv-below .cv-disclaimer { margin-top: 14px; text-align: center; }
/* The front page's line, under the box (ChatView lineBelowBox): "Ask
   anything." sits right over the box, and the line says what this is. */
.cv-below .cv-welcome-text { margin-top: 16px; text-align: center; }
.cv-below .cv-welcome-text + .cv-starters { margin-top: 22px; }

/* The first view of a visit (ChatView REVEAL; Alexi, Oct 17, v2): the first
   frame is "Ask anything." typing over the box, and nothing else. The line
   under the box fades in as the caret drops into it; at 4 s the four
   questions, one by one (the first with the list's top rule); then the menu
   (the desktop's rail, the phone's menu button) and More questions; then Ask
   glimmers twice; last, slowly, the AI notice (its crisis link) and the fine
   print. Opacity only: everything holds its place from the first frame, so
   nothing moves. What isn't in yet can't be tapped, and a screen reader
   still finds all of it, the AI notice from the first frame. The header's
   lockup is never held back. ChatView sets these classes only while it
   plays: without them (a repeat view, an ad's landing, a link with words,
   a crisis hold, reduced motion, a high-contrast mode, no script at all)
   everything is simply there. The menu and the AI notice live in the app's
   shell, outside this view: they are held while this view holds them
   (:has). A browser without :has never holds them, so the AI notice is
   there from the first frame; and a notice still drawn see-through once the
   reveal is over is made visible (ChatView noticeIn). Anyone starting takes
   every class away at once, and the fades with them: the fades are
   animations, which end the moment .is-revealing goes (a transition would
   play on to its end). Each lasts as long as ChatView says
   (REVEAL_STYLE sets --reveal-* on the page), and none outlasts it (no
   fill): a finished fade left in place would keep Chrome from counting the
   line as painted (Largest Contentful Paint) until the end. */
.chat-view.holds-line .cv-below .cv-welcome-text,
.chat-view.holds-q1 .cv-starters,
.chat-view.holds-q2 .cv-starters > li:nth-child(2),
.chat-view.holds-q3 .cv-starters > li:nth-child(3),
.chat-view.holds-q4 .cv-starters > li:nth-child(4),
.chat-view.holds-menu .cv-more-starters,
.chat-view.holds-notice .cv-below .cv-disclaimer,
.app-shell:has(.chat-view.holds-menu) .sidebar,
.app-shell:has(.chat-view.holds-menu) .shell-hamburger,
.app-shell:has(.chat-view.holds-notice) .ai-disclosure {
  opacity: 0;
  pointer-events: none;
}
.chat-view.is-revealing:not(.holds-line) .cv-below .cv-welcome-text { animation: cv-reveal-in var(--reveal-line) var(--ease-out); }
.chat-view.is-revealing:not(.holds-q1) .cv-starters,
.chat-view.is-revealing:not(.holds-q2) .cv-starters > li:nth-child(2),
.chat-view.is-revealing:not(.holds-q3) .cv-starters > li:nth-child(3),
.chat-view.is-revealing:not(.holds-q4) .cv-starters > li:nth-child(4) { animation: cv-reveal-in var(--reveal-question) var(--ease-out); }
.chat-view.is-revealing:not(.holds-menu) .cv-more-starters,
.app-shell:has(.chat-view.is-revealing:not(.holds-menu)) .sidebar,
.app-shell:has(.chat-view.is-revealing:not(.holds-menu)) .shell-hamburger { animation: cv-reveal-in var(--reveal-menu) var(--ease-out); }
/* Very slowly, and evenly: the notice's words are read, not noticed moving.
   Only when it was held back (stages-notice: ChatView's
   AI_NOTICE_NOT_BEFORE_MS at 0 never holds it, and then it never fades). */
.chat-view.is-revealing.stages-notice:not(.holds-notice) .cv-below .cv-disclaimer,
.app-shell:has(.chat-view.is-revealing.stages-notice:not(.holds-notice)) .ai-disclosure { animation: cv-reveal-in var(--reveal-notice) ease-in-out; }
@keyframes cv-reveal-in {
  from { opacity: 0; }
  to { opacity: 1; }
}
/* The caret lands in the box still; its four blinks wait for the rest. */
.chat-view.is-revealing .cv-static-caret.is-welcome { animation: none; }
/* The page listens for a tap while it plays (ChatView): no grey flash on an
   iPhone. */
.chat-view.is-revealing { -webkit-tap-highlight-color: transparent; }

/* Ask's glimmer, once, in the first view (ChatView REVEAL): two soft sweeps,
   the starters' glimmer made for a button. A faint band of light crosses the
   quiet Ask, and its word and edge brighten to the text colour as it passes.
   Monochrome, like everything else: on Day's white box the band would be
   lost, so there it is the word and the edge alone. Never with reduced
   motion (the first view isn't staged then either). */
.chat-view.is-glimmering .cv-icon-btn.send {
  position: relative;
  isolation: isolate;
  animation: cv-ask-glint var(--reveal-glimmer) cubic-bezier(0.45, 0, 0.2, 1) 2;
}
.chat-view.is-glimmering .cv-icon-btn.send::before {
  content: '';
  position: absolute;
  inset: 0;
  z-index: -1;
  border-radius: inherit;
  pointer-events: none;
  background: linear-gradient(105deg, transparent 25%, var(--cv-ask-sheen, color-mix(in srgb, var(--brand-fg) 18%, transparent)) 50%, transparent 75%) no-repeat;
  background-size: 70% 100%;
  background-position: -120% 0;
  opacity: 0;
  animation: cv-ask-sheen var(--reveal-glimmer) cubic-bezier(0.45, 0, 0.2, 1) 2;
}
:root[data-theme="day"] { --cv-ask-sheen: transparent; }
@keyframes cv-ask-glint {
  0%, 100% { color: var(--brand-muted); border-color: var(--brand-line-control); }
  45%, 60% { color: var(--brand-fg); border-color: var(--brand-fg); }
}
@keyframes cv-ask-sheen {
  0% { opacity: 0; background-position: -120% 0; }
  20% { opacity: 1; }
  80% { opacity: 1; }
  100% { opacity: 0; background-position: 220% 0; }
}
@media (prefers-reduced-motion: reduce) {
  .chat-view.is-glimmering .cv-icon-btn.send,
  .chat-view.is-glimmering .cv-icon-btn.send::before { animation: none !important; }
}

/* A statement or your-turn landing: the ad's words, then the box. */
.cv-landing {
  margin: 4px 0 24px;
}

/* ---- support (utils/giving.js) --------------------------------------------- */

/* Every third question: one muted line under the answer, with no box,
   never louder than the answer itself. */
.cv-support {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 0 0 18px 2px;
  max-width: var(--measure);
  font-size: 0.8125rem;
  line-height: 1.5;
  color: var(--brand-muted);
}

.cv-support .apr-icon {
  margin-top: 2px;
  color: var(--brand-subtle);
}

.cv-support a {
  color: inherit;
}

.cv-support a:hover {
  color: var(--brand-fg);
}

.cv-msg.streaming .cv-support { margin-top: 14px; }
.cv-answer-meta + .cv-support { margin-top: -6px; }

/* The 988 line: where the support line would stand on the cards in the box's
   place, and under the questions-left line, in a conversation that had a
   crisis card. As quiet as the support line; the number is a real link. */
.cv-crisis-line {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 0 2px 8px;
  max-width: var(--measure);
  font-size: 0.8125rem;
  line-height: 1.5;
  color: var(--brand-muted);
}

.cv-crisis-line .apr-icon {
  margin-top: 2px;
  color: var(--brand-subtle);
}

.cv-crisis-line a {
  color: var(--brand-fg);
  font-weight: 600;
}

/* ---- cards in the conversation: the account nudge, giving ---------------- */

.cv-card {
  margin: 4px 0 26px;
  padding: 16px 18px;
  border-radius: var(--radius-lg);
  border: 1px solid var(--brand-line);
  background: var(--brand-surface);
  max-width: var(--measure);
}

.cv-card p {
  margin: 0;
  font-size: 0.9375rem;
  line-height: 1.55;
  color: var(--brand-fg-read);
}

.cv-card strong { color: var(--brand-fg); font-weight: 600; }

.cv-card-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
  margin-top: 14px;
}

/* ---- the real Rob, and the next-step ladder (§11.1) ----------------------- */

.cv-rob {
  margin: 4px 0 6px;
}

.cv-rob-media {
  position: relative;
  margin-top: 8px;
  aspect-ratio: 16 / 9;
  border-radius: var(--radius-lg);
  overflow: hidden;
  background: var(--brand-surface-2);
}

.cv-rob-media video,
.cv-rob-play img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 50% 18%;
}

.cv-rob-play {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  padding: 0;
}

.cv-rob-play-ring {
  position: absolute;
  left: 50%;
  top: 50%;
  display: grid;
  place-items: center;
  width: 56px;
  height: 56px;
  margin: -28px 0 0 -28px;
  border-radius: 50%;
  border: 2px solid #fff;
  background: rgba(0, 0, 0, 0.72);
  color: #fff;
}

.cv-rob-placeholder {
  position: absolute;
  left: 10px;
  top: 10px;
  padding: 4px 6px;
  font-size: 0.6875rem;
  font-weight: 600;
  background: #000;
  color: #fff;
  outline: 1px solid var(--brand-danger);
}

.cv-rob-meta {
  margin-top: 8px;
  font-size: 0.8125rem;
  line-height: 1.4;
  color: var(--brand-muted);
}

.cv-ladder {
  margin: 22px 0 28px;
  max-width: var(--measure);
}

.cv-step + .cv-step { margin-top: 14px; }
.cv-ladder .cv-label + .cv-step { margin-top: 10px; }

.cv-step-desc {
  margin: 6px 2px 0;
  font-size: 0.875rem;
  line-height: 1.4;
  color: var(--brand-muted);
}

/* ---- "Ask the real Rob" ---------------------------------------------------- */

.askrob-panel {
  margin: 0 0 20px;
  padding: 18px;
  border-radius: var(--radius-lg);
  border: 1px solid var(--brand-line-control);
  background: var(--brand-surface);
  max-width: var(--measure);
}

.askrob-title {
  margin: 0;
  font-size: 1.0625rem;
  line-height: 1.35;
  font-weight: 600;
  color: var(--brand-fg);
}

.askrob-head p {
  margin: 6px 0 0;
  font-size: 0.9375rem;
  line-height: 1.5;
  color: var(--brand-fg-read);
}

.askrob-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-top: 16px;
}

.askrob-grid label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--brand-muted);
}

.askrob-grid label em { font-style: normal; font-weight: 500; color: var(--brand-subtle); }
.askrob-wide { grid-column: 1 / -1; }
.chat-view .askrob-grid textarea { min-height: 84px; resize: vertical; }

.askrob-actions {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 16px;
}

.askrob-error { margin-top: 12px; }

.askrob-sent {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 0;
  font-size: 0.9375rem;
  line-height: 1.5;
  color: var(--brand-fg-read);
}

.askrob-sent strong { color: var(--brand-fg); }
.askrob-sent .apr-icon { margin-top: 2px; }
/* The 988 line, always in the panel; the safe-way line when abuse came up. */
.askrob-988,
.askrob-safe {
  margin: 10px 0 0;
  font-size: 0.875rem;
  line-height: 1.5;
  color: var(--brand-fg-read);
}
.askrob-safe { color: var(--brand-fg); }
.askrob-card { margin: 0 0 12px; }

/* ---- jump to the latest ---------------------------------------------------- */

.cv-jump {
  position: absolute;
  right: 16px;
  bottom: 12px;
  z-index: 3;
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 1px solid var(--brand-line-control);
  background: var(--brand-surface);
  color: var(--brand-fg);
}

.cv-jump:hover { background: var(--brand-surface-2); }

/* ---- bars docked above the composer: AI Rob's voice, the human door ------- */

.cv-voice-bar,
.cv-door {
  flex: none;
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 48px;
  padding: 0 max(20px, calc((100% - var(--column-chat)) / 2));
  background: var(--brand-surface);
  border-top: 1px solid var(--brand-line);
}

.cv-voice-bar {
  flex-wrap: wrap;
  padding-top: 8px;
  padding-bottom: 8px;
  gap: 8px 12px;
}

.cv-voice-label {
  flex: 1 1 12em;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--brand-fg-read);
}

/* The team's line: which voice is reading, and why Grok read when ElevenLabs was picked. */
.cv-voice-who { color: var(--brand-fg); font-weight: 600; white-space: nowrap; }

.cv-voice-note {
  display: block;
  margin-top: 2px;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.4;
  color: var(--brand-muted);
}

.cv-voice-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.cv-voice-stop {
  min-height: 44px;
  padding: 0 14px;
  font-size: 0.9375rem;
}

.cv-voice-type { font-size: 0.9375rem; }

.cv-door {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--brand-fg-read);
}

.cv-door > .apr-icon { color: var(--brand-muted); }

.cv-door-text {
  flex: 1;
  min-width: 0;
}

.cv-door-btn {
  flex: none;
  min-height: 44px;
  padding: 0 2px;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--brand-fg);
  text-decoration-line: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 0.2em;
}

.cv-door-btn:hover { text-decoration-thickness: 2px; }

/* ---- the composer (§11.1) -------------------------------------------------- */

.cv-composer {
  flex-shrink: 0;
  padding: 10px 0 calc(6px + env(safe-area-inset-bottom, 0px));
  background: var(--brand-bg);
}

/* A card in the box's place (the email gate, the window's limit) or the
   email form above the box can outgrow a small phone: the conversation
   keeps a glimpse of the question, and the card scrolls instead of being
   cut off. */
.chat-view.has-card .cv-composer {
  flex-shrink: 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.chat-view.has-card .cv-messages-wrap { min-height: 72px; }

.cv-form { display: flex; flex-direction: column; }

/* ---- "Ask about this" (utils/quote.js) ---------------------------------------

   Words selected in a finished answer offer "Ask about this" at the top of
   the composer, never over the words; a tap puts them in a quote above the
   box, and the turn shows them above the person's own words. A quote is AI
   Rob's words, so it is set in the sans (§6.2), italic at Alexi's request
   (Oct 2026: BRAND_SPEC §6.5's exception), between curly quotes and beside a
   thin rule. Its italic is a real one (public/fonts/inter-italic-latin.woff2,
   fetched only when one is on screen), never one the browser fakes:
   --quote-style: normal sets every quote upright again. Text and label are
   7:1 or better in Night and Day. */

.cv-ask-offer-row {
  display: flex;
  margin: 0 0 8px;
}

.cv-ask-offer {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  padding: 0 16px 0 14px;
  border-radius: 22px;
  border: 1px solid var(--brand-line-control);
  background: var(--brand-surface);
  color: var(--brand-fg);
  font-size: 0.9375rem;
  font-weight: 600;
  line-height: 1.2;
  animation: cv-ask-in var(--dur-fast) var(--ease-out);
}

.cv-ask-offer .apr-icon { flex: none; color: var(--brand-muted); }
.cv-ask-offer:hover { background: var(--brand-surface-2); }

@keyframes cv-ask-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

.cv-quote-chip {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  margin: 0 0 8px;
  padding: 10px 0 10px 14px;
  border-radius: var(--radius-lg);
  border: 1px solid var(--brand-line-control);
  background: var(--brand-surface);
}

.cv-quote {
  min-width: 0;
  margin: 0;
  padding: 1px 0 1px 12px;
  border-left: 2px solid var(--brand-line-control);
}

.cv-quote.is-chip { flex: 1 1 auto; }
.cv-quote.is-turn { margin: 8px 0 0; }

/* The quote follows the question in the page (ChatParts UserTurn: a screen
   reader jumping to the heading hears what "this" is next) and shows above
   it: "You", the quote, then their words. A flex column keeps the gaps the
   block layout had (8 px each; margins don't collapse here). */
.cv-msg.user.quoting { display: flex; flex-direction: column; }
.cv-msg.user.quoting > .cv-label { order: -2; }
.cv-msg.user.quoting > .cv-quote.is-turn { order: -1; }

.cv-quote-label {
  display: block;
  font-size: 0.8125rem;
  line-height: 1.35;
  font-weight: 500;
  color: var(--brand-muted);
}

.cv-quote-text {
  display: block;
  margin: 2px 0 0;
  font-family: var(--font-sans);
  font-style: var(--quote-style, italic);
  font-synthesis: none;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5;
  color: var(--brand-fg-read);
  white-space: pre-line;
  overflow-wrap: anywhere;
  quotes: "“" "”" "‘" "’";
}

.cv-quote-text::before { content: open-quote; }
.cv-quote-text::after { content: close-quote; }

/* Above the box: two lines at most, then an ellipsis. */
.cv-quote.is-chip .cv-quote-text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow: hidden;
  font-size: 0.9375rem;
  line-height: 1.45;
}

.cv-quote-remove {
  flex: none;
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  margin: -6px 0 -6px 0;
  border-radius: 50%;
  color: var(--brand-muted);
}

.cv-quote-remove:hover { background: var(--brand-surface-2); color: var(--brand-fg); }

/* A short screen (a small phone with its keyboard up) keeps the conversation
   in sight: one line of the quote. */
@media (max-height: 600px) {
  .cv-quote.is-chip .cv-quote-text { -webkit-line-clamp: 1; line-clamp: 1; }
}

@media (prefers-reduced-motion: reduce) {
  .cv-ask-offer { animation: none; }
}

.cv-quota {
  margin: 0 2px 8px;
  font-size: 0.8125rem;
  font-weight: 500;
  color: var(--brand-muted);
}

.cv-link {
  padding: 0;
  font: inherit;
  color: var(--brand-fg);
  text-decoration: underline;
  text-underline-offset: 0.2em;
}

.cv-input-row {
  --cv-row-pad: 3px;
  position: relative;
  display: flex;
  align-items: flex-end;
  gap: 8px;
  min-height: 52px;
  padding: var(--cv-row-pad) var(--cv-row-pad) var(--cv-row-pad) 16px;
  border-radius: var(--radius-lg);
  border: 1px solid var(--brand-line-control);
  background: var(--brand-surface);
  cursor: text;
}

.cv-input-row:focus-within {
  border-color: var(--brand-fg);
  box-shadow: inset 0 0 0 1px var(--brand-fg);
}

.chat-view .cv-input {
  flex: 1;
  min-width: 0;
  min-height: 44px;
  max-height: 160px;
  padding: 10px 0;
  background: transparent;
  border: 0;
  border-radius: 0;
  box-shadow: none;
  color: var(--brand-fg);
  font-size: 1.0625rem; /* 16 px or more stops iOS zooming */
  line-height: 1.4;
  resize: none;
  outline: none;
  caret-color: var(--brand-caret);
}

.chat-view .cv-input:focus { outline: none; box-shadow: none; border: 0; }

/* The placeholder says what to do, in the muted grey rather than the subtle
   one (8.5:1 on Night, 8.4:1 on Day): plainly readable, still unlike words
   someone has typed. */
.chat-view .cv-input::placeholder {
  color: var(--brand-muted);
  /* In Newsreader italic (Alexi, Oct 17): the serif is a person's words, and
     the slant says "your words go here" (public/fonts/newsreader-italic-latin.woff2). */
  font-family: var(--font-serif);
  font-style: italic;
  /* One line, always: on the narrowest phones a wrapped placeholder was
     clipped mid-word by the one-row box. */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chat-view .cv-input:disabled { opacity: 1; color: var(--brand-fg); }

/* The front page's box for a first question (.first-turn: the welcome, a
   statement or your-turn landing), for someone who has never typed to a
   website before (Alexi, Oct 2026: clear to an 84-year-old): a 2 px edge in
   the muted grey (9.4:1 on Night's black, 7.5:1 on Day's cream), and its
   words, placeholder and "Ask" a size up, 20 px. Focused, the edge turns
   white (black on Day) and the focus ring goes round it (§11.0 Inputs).
   Once a conversation is under way the box is the compact one again, with
   its 1 px control edge. */
.chat-view.first-turn .cv-input-row {
  --cv-row-pad: 2px;
  border: 2px solid var(--brand-muted);
}
.chat-view.first-turn .cv-input-row:focus-within { border-color: var(--brand-fg); box-shadow: none; }
.chat-view.first-turn .cv-input-row:has(.cv-input:focus) {
  box-shadow: 0 0 0 2px var(--brand-focus-offset), 0 0 0 4px var(--brand-focus);
}
.chat-view.first-turn .cv-input,
.chat-view.first-turn .cv-static-caret,
.chat-view.first-turn .cv-icon-btn.cv-word { font-size: 1.25rem; }
.chat-view.first-turn .cv-voice-level { right: 140px; } /* clear of the mic and the wider Ask */
/* On a phone its words get the whole width of the box, and the mic and Ask
   sit on a row under them, at its two ends (a slip off Ask never starts the
   mic), so "Type your question here" is never cut short, even at 320 px. */
@media (max-width: 480px) {
  .chat-view.first-turn .cv-input-row {
    flex-wrap: wrap;
    justify-content: flex-end;
    row-gap: 0;
    container-type: inline-size; /* for the zoomed-in rule just below */
  }
  .chat-view.first-turn .cv-input { flex: 1 0 100%; padding: 10px 14px 6px 0; }
  .chat-view.first-turn .cv-icon-btn.mic { margin-right: auto; }
  .chat-view.first-turn .cv-voice-level { right: 16px; bottom: 48px; }
  /* Zoomed in, or with large text (a 390 px iPhone at 150 %, an Android
     phone with its text enlarged), the placeholder can't fit on one line:
     it wraps, and the empty box has room for both lines. In rem, so larger
     text needs a wider box before it comes back to one line. */
  @container (max-width: 16rem) {
    .chat-view.first-turn .cv-input::placeholder { white-space: normal; }
    .chat-view.first-turn .cv-input:placeholder-shown { min-height: calc(2.8em + 16px); }
  }
}
/* The narrowest phones: a pixel smaller. */
@media (max-width: 340px) {
  .chat-view.first-turn .cv-input,
  .chat-view.first-turn .cv-static-caret,
  .chat-view.first-turn .cv-icon-btn.cv-word { font-size: 1.1875rem; }
}

/* The box's caret before anyone types (decorative, aria-hidden): the brand
   caret's shape (§4) in ems of the box's words, hanging below their
   baseline, just before where they start, so the placeholder never moves.
   Still on a statement landing (§11.1). On the default welcome it comes once
   "Ask anything." has typed, blinks four times (4,240 ms, §9.2: WCAG 2.2.2)
   and then stays. It steps aside (.is-aside) while the box has focus or
   words, so there is one live caret: the box's own takes over where the
   words start, about 4 px to its right (the gap keeps this one clear of the
   placeholder's first letter). */
.cv-static-caret {
  position: absolute;
  left: 11px;
  top: calc(var(--cv-row-pad) + 10px + 0.28em);
  width: max(2px, var(--caret-width));
  height: var(--caret-height);
  font-size: 1.0625rem; /* the box's words */
  background: var(--brand-caret);
  pointer-events: none;
}
.cv-static-caret.is-aside { visibility: hidden; }
.cv-static-caret.is-welcome {
  animation: cv-caret-blink calc(var(--caret-on) + var(--caret-off)) steps(1, end) 4;
}
@keyframes cv-caret-blink {
  0% { opacity: 1; }
  50% { opacity: 0; }
}
@media (prefers-reduced-motion: reduce) {
  .cv-static-caret.is-welcome { animation: none; }
}
/* High-contrast modes would paint it the box's own colour: the text colour. */
@media (forced-colors: active) {
  .cv-static-caret { forced-color-adjust: none; background: CanvasText; }
}

.cv-icon-btn {
  flex-shrink: 0;
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 1px solid var(--brand-line-control);
  background: transparent;
  color: var(--brand-muted);
}

.cv-icon-btn:hover:not(:disabled) { background: var(--brand-surface-2); color: var(--brand-fg); }
.cv-icon-btn:disabled { cursor: default; color: var(--brand-line-control); }

/* The live action has the 2 px line: Ask once there is a question (or the
   mic is listening), Stop while answering, the mic while it records. */
.cv-icon-btn.send:not(:disabled):not([aria-disabled="true"]),
.cv-icon-btn.send.stop,
.cv-icon-btn.mic.recording {
  border: 2px solid var(--brand-fg);
  color: var(--brand-fg);
}

/* Ask, once there's a question to ask, fills (Alexi, Oct 17: "a soft
   highlight on the send"): solid white with black words on Night, black with
   cream on Day, so it is plainly the thing to press. It eases in once, the
   moment the first letter lands; no glow (§5), and no easing with reduced
   motion. Stop keeps the 2 px line only. */
.cv-icon-btn.send:not(.stop):not(:disabled):not([aria-disabled="true"]) {
  background: var(--brand-fg);
  color: var(--brand-bg);
}
.cv-icon-btn.send { transition: background-color 0.45s ease, color 0.45s ease; }
@media (prefers-reduced-motion: reduce) {
  .cv-icon-btn.send { transition: none; }
}

/* "Ask" and "Stop", in words: a pill beside the round mic, 44 px tall, 17 px
   type (20 px in the first question's box), the words someone reads to act.
   The same width whichever it says, quiet (the 1 px control edge, the muted
   grey, still easy to read) or live (2 px): the mic beside it never moves. */
.cv-icon-btn.cv-word {
  width: auto;
  min-width: 4em;
  padding: 0 0.75em;
  border-radius: 22px;
  font-size: 1.0625rem;
  font-weight: 600;
  line-height: 1;
}
.cv-icon-btn.cv-word[aria-disabled="true"] { color: var(--brand-muted); }

.cv-icon-btn.mic.busy { cursor: wait; }

/* One 2 px white line shows the voice level while recording (§11.1). */
.cv-voice-level {
  position: absolute;
  left: 16px;
  right: 128px; /* clear of the mic and Ask */
  bottom: 6px;
  height: 2px;
  pointer-events: none;
}

.cv-voice-level > span {
  display: block;
  height: 2px;
  background: var(--brand-fg);
  transform-origin: left center;
  transform: scaleX(0.06);
}

@media (prefers-reduced-motion: reduce) {
  .cv-voice-level > span { transform: none; opacity: 0.6; }
}

/* Everything under the input row except the fine print sits in one
   collapsible grid row so phones can fold it away while reading. The
   1fr -> 0fr transition animates to the content's real height. */
.cv-chrome {
  display: grid;
  grid-template-rows: 1fr;
  transition: grid-template-rows var(--dur-base) var(--ease-out), opacity var(--dur-fast) var(--ease-out);
}

.cv-chrome-inner {
  min-height: 0;
  overflow: hidden;
  /* room for the focus ring, which the clip would otherwise cut */
  margin: 0 -6px;
  padding: 0 6px;
  transition: visibility 0s;
}

/* Compact composer (phones in either orientation; ChatView only sets the
   class when its COMPACT_QUERY matches): after 5 s idle or a scroll down the
   toolbar fades and folds, and the box drops toward the bottom edge.
   Focusing or typing unfolds it. visibility waits for the fold so the
   buttons stay visible while they fade, then leave the tab order. */
.cv-composer.collapsed .cv-chrome { grid-template-rows: 0fr; opacity: 0; }
.cv-composer.collapsed .cv-chrome-inner { visibility: hidden; transition-delay: var(--dur-base); }

.cv-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 8px 0 2px;
}

/* Fast / Deeper: a segmented choice. Selected = a 2 px white edge and a
   check, never a fill (§11.0). */
.cv-tier {
  display: inline-flex;
}

.cv-tier-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 44px;
  padding: 0 14px;
  border: 1px solid var(--brand-line-control);
  background: transparent;
  color: var(--brand-muted);
  font-size: 0.875rem;
  font-weight: 600;
}

.cv-tier-btn:first-child { border-radius: var(--radius-md) 0 0 var(--radius-md); }
.cv-tier-btn:last-child { border-radius: 0 var(--radius-md) var(--radius-md) 0; margin-left: -1px; }
.cv-tier-btn:hover { color: var(--brand-fg); }

.cv-tier-btn.on {
  position: relative;
  z-index: 1;
  border-color: var(--brand-fg);
  box-shadow: inset 0 0 0 1px var(--brand-fg);
  color: var(--brand-fg);
}

.cv-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  padding: 0 12px;
  border-radius: var(--radius-md);
  border: 1px solid var(--brand-line-control);
  background: transparent;
  color: var(--brand-fg);
  font-size: 0.875rem;
  font-weight: 600;
  white-space: nowrap;
}

button.cv-pill:hover:not(:disabled) { background: var(--brand-surface-2); }
.cv-pill.saved { color: var(--brand-muted); border-color: var(--brand-line); }
.cv-pill.voice { color: var(--brand-muted); }
.cv-pill.voice.on { color: var(--brand-fg); }
.cv-pill:disabled { color: var(--brand-line-control); }

.cv-pill .apr-switch-track {
  width: 34px;
  height: 20px;
}

.cv-pill .apr-switch-track::after {
  width: 12px;
  height: 12px;
}

.cv-pill[aria-checked="true"] > .apr-switch-track::after {
  transform: translateX(14px);
}

/* The fine print stays under the box (§11.1). Only a landscape phone, where
   every line of reading room counts, folds it with the toolbar while reading;
   it comes back with the toolbar. */
.cv-disclaimer {
  margin: 8px 2px 2px;
  font-size: 0.8125rem;
  line-height: 1.4;
  color: var(--brand-subtle);
}
.cv-disclaimer-line { display: block; }
.cv-disclaimer a { color: inherit; text-decoration: underline; text-underline-offset: 2px; }

@media (max-height: 500px) {
  .cv-composer.collapsed .cv-disclaimer {
    display: none;
  }
}

/* ---- the window's limit, and the email gate (§11.1) ------------------------ */

.cv-limit {
  padding: 18px;
  border-radius: var(--radius-lg);
  border: 1px solid var(--brand-line-control);
  background: var(--brand-surface);
}

.cv-limit-title {
  margin: 0;
  font-size: 1.0625rem;
  line-height: 1.35;
  font-weight: 600;
  color: var(--brand-fg);
}

.cv-limit-text {
  margin: 4px 0 0;
  font-size: 0.9375rem;
  line-height: 1.5;
  color: var(--brand-fg-read);
}

.cv-limit .cv-support,
.cv-limit .cv-crisis-line { margin: 12px 0 0; }

/* "Want to keep going?": the email form under the card's words. */
.cv-gate .email-signup { margin-top: 14px; }

.cv-gate-later {
  margin: 2px 0 0;
  font-size: 0.875rem;
  line-height: 1.45;
  color: var(--brand-muted);
}

/* The email form opened from the questions-left line. */
.cv-quota-join {
  margin: 0 0 10px;
  padding: 14px 16px;
  border-radius: var(--radius-lg);
  border: 1px solid var(--brand-line-control);
  background: var(--brand-surface);
}

/* "Thanks! You're in.": a moment above the box, then gone. */
.cv-joined {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 2px 8px;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--brand-fg-read);
}

.cv-limit-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-top: 16px;
}

/* ---- Focused Study headers -------------------------------------------------- */

.cv-header {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 60px;
  padding: 8px max(20px, calc((100% - var(--column-chat)) / 2));
  border-bottom: 1px solid var(--brand-line);
  background: var(--brand-bg);
}

.cv-header-title { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 1px; }

.cv-header-title h2 {
  margin: 0;
  font-family: var(--font-sans);
  font-size: 1rem;
  line-height: 1.3;
  font-weight: 600;
  color: var(--brand-fg);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cv-header-sub {
  font-size: 0.8125rem;
  line-height: 1.4;
  color: var(--brand-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cv-header-sub a { color: var(--brand-fg); }

.cv-back {
  flex: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 44px;
  padding: 0 12px 0 8px;
  border-radius: var(--radius-md);
  border: 1px solid var(--brand-line-control);
  color: var(--brand-fg);
  font-size: 0.9375rem;
  font-weight: 600;
  white-space: nowrap;
}

.cv-back:hover { background: var(--brand-surface-2); }
.cv-header-right { display: flex; align-items: center; gap: 8px; }

/* The sermon list (several sermons) */
.cv-sermons { position: relative; }

.cv-sermons-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 44px;
  padding: 0 12px;
  border-radius: var(--radius-md);
  border: 1px solid var(--brand-line-control);
  color: var(--brand-fg);
  font-size: 0.875rem;
  font-weight: 600;
}

.cv-sermons-btn:hover { background: var(--brand-surface-2); }
.cv-sermons-btn[aria-expanded="true"] .cv-sermons-chevron { transform: rotate(180deg); }

.cv-sermons-list {
  position: absolute;
  top: calc(100% + 6px);
  /* The button sits at the right end of the header: open leftward, so the
     list stays on screen on a phone instead of running off its right edge. */
  right: 0;
  z-index: 20;
  width: min(420px, 86vw);
  max-height: 320px;
  overflow-y: auto;
  padding: 6px;
  border-radius: var(--radius-lg);
  border: 1px solid var(--brand-line-control);
  background: var(--brand-surface);
}

.cv-sermons-item {
  display: flex;
  gap: 10px;
  align-items: baseline;
  min-height: 44px;
  padding: 10px;
  border-radius: var(--radius-md);
  font-size: 0.9375rem;
  line-height: 1.35;
  color: var(--brand-fg);
  text-decoration: none;
}

.cv-sermons-item:hover { background: var(--brand-surface-2); text-decoration: none; }
.cv-sermons-item .n { min-width: 20px; color: var(--brand-muted); font-weight: 600; font-variant-numeric: tabular-nums; }
.cv-sermons-item .d { margin-left: auto; white-space: nowrap; font-size: 0.8125rem; color: var(--brand-muted); }

.cv-context { display: inline-flex; align-items: center; gap: 6px; font-size: 0.8125rem; color: var(--brand-muted); white-space: nowrap; font-variant-numeric: tabular-nums; }
.cv-context-bar { width: 64px; height: 6px; border-radius: 3px; border: 1px solid var(--brand-line-control); overflow: hidden; }
.cv-context-fill { height: 100%; background: var(--brand-fg); }

/* ---- smaller screens -------------------------------------------------------- */

@media (max-width: 720px) {
  .cv-scroll { padding-top: 16px; }
  .askrob-grid { grid-template-columns: 1fr 1fr; }
  .cv-welcome { margin-top: 4vh; }
  .cv-header-right .cv-context { display: none; }
  .cv-jump { right: 12px; bottom: 10px; }
  .cv-limit-actions { flex-direction: column; align-items: stretch; }
  .cv-limit-actions .apr-btn { width: 100%; }
  .askrob-actions .apr-btn { flex: 1 1 auto; }
}

@media (max-width: 420px) {
  .askrob-grid { grid-template-columns: 1fr; }
  .cv-tier-btn { padding: 0 12px; }
  .cv-action { padding: 0 10px; }
}

/* The smallest phones: "Sermons" folds into the arrow so the study title can
   be read, and the placeholder steps down to fit the box (only the input's
   own size matters to iOS zoom, not its placeholder's). */
@media (max-width: 360px) {
  .cv-back-label { display: none; }
  .cv-back { padding: 0 10px; }
  .cv-header { gap: 8px; padding-left: 16px; padding-right: 16px; }
  .cv-sermons-btn { padding: 0 10px; }
  .chat-view:not(.first-turn) .cv-input::placeholder { font-size: 15px; }
  .cv-question.size-lead { font-size: 1.75rem; }
}

@media (prefers-reduced-motion: reduce) {
  .cv-msg.user.landing > *,
  .cv-fresh { animation: none; }
  .cv-chrome,
  .cv-chrome-inner,
  .cv-header-slot,
  .chat-view.tucked .cv-header-slot { transition: none; }
}

/* Two short lines on a phone: the fine print steps down a notch so neither wraps. */
@media (max-width: 430px) {
  .cv-disclaimer { font-size: 0.75rem; }
}
`, "",{"version":3,"sources":["webpack://./src/components/ChatView.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,0CAA0C;EAC1C,cAAc;EACd,eAAe;AACjB;;AAEA;;uDAEuD;AACvD;EACE,cAAc;EACd;;;2BAGyB;AAC3B;;AAEA;EACE,+CAA+C;EAC/C,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB;;;wCAGsC;AACxC;;AAEA,6EAA6E;;AAE7E;EACE,OAAO;EACP,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,iCAAiC;EACjC,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA,UAAU,WAAW,EAAE;;AAEvB;8DAC8D;AAC9D,iBAAiB,SAAS,EAAE,oBAAoB,EAAE;;AAElD;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,cAAc;EACd,sBAAsB;AACxB;;AAEA,2EAA2E;AAC3E;EACE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;;0BAE0B;AAC1B;EACE,iDAAiD;AACnD;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,KAAK,eAAe,EAAE;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA,qEAAqE;AACrE;EACE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,gFAAgF;AAChF,kBAAkB,eAAe,EAAE;;AAEnC;;eAEe;AACf,YAAY,sDAAsD,EAAE;;AAEpE;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;kDACkD;AAClD;EACE,qBAAqB;EACrB,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;;EAEE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,iBAAiB,gBAAgB,EAAE,cAAc,EAAE;AACnD,4BAA4B,gBAAgB,EAAE;AAC9C;;;EAGE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;;8BAE8B,aAAa,EAAE;AAC7C;kBACkB,kBAAkB,EAAE,mBAAmB,EAAE;AAC3D,kBAAkB,aAAa,EAAE,iBAAiB,EAAE;AACpD,0BAA0B,yBAAyB,EAAE;AACrD,oBAAoB,SAAS,EAAE;AAC/B,sBAAsB,sBAAsB,EAAE,gBAAgB,EAAE;AAChE,0EAA0E;AAC1E,kBAAkB,kBAAkB,EAAE,sBAAsB,EAAE;AAC9D,kBAAkB,SAAS,EAAE,uCAAuC,EAAE,cAAc,EAAE;AACtF;EACE,2DAA2D;EAC3D,iBAAiB;EACjB,qBAAqB;EACrB,+BAA+B;EAC/B,kCAAkC;EAClC,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,8BAA8B;EAC9B,4BAA4B;AAC9B;AACA,uBAAuB,8BAA8B,EAAE;;AAEvD;wEACwE;AACxE;EACE,cAAc;EACd,uBAAuB;EACvB,gDAAgD;EAChD,2BAA2B;AAC7B;;AAEA;kEACkE;AAClE;;EAEE,8BAA8B;EAC9B,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;sEACsE;AACtE,6BAA6B,kBAAkB,EAAE;AACjD;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,cAAc,EAAE,6CAA6C;EAC7D,qBAAqB;EACrB,mBAAmB;AACrB;AACA;;mEAEmE;AACnE,qCAAqC,YAAY,EAAE,yBAAyB,EAAE;AAC9E;kEACkE;AAClE;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,+BAA+B;EAC/B,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA,qCAAqC,yBAAyB,EAAE,qBAAqB,EAAE,eAAe,EAAE;AACxG,gCAAgC,kCAAkC,EAAE;AACpE,0EAA0E;AAC1E;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;sEACsE;AACtE;EACE,0BAA0B,kBAAkB,EAAE;EAC9C,iCAAiC,WAAW,EAAE,kBAAkB,EAAE,iBAAiB,EAAE;EACrF;8EAC4E;EAC5E,sCAAsC,OAAO,EAAE;EAC/C,sDAAsD,QAAQ,EAAE;AAClE;;AAEA,mEAAmE;AACnE;EACE;IACE,qBAAqB;IACrB,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,kBAAkB;EACpB;AACF;;AAEA;;;;;;;8BAO8B;AAC9B,6BAA6B,eAAe,EAAE,kBAAkB,EAAE,wCAAwC,EAAE;AAC5G,oCAAoC,kCAAkC,EAAE;AACxE,2CAA2C,sBAAsB,EAAE;AACnE,+DAA+D,qCAAqC,EAAE,6BAA6B,EAAE,gDAAgD,EAAE;AACvL,wBAAwB,8CAA8C,sBAAsB,EAAE,oCAAoC,EAAE,mCAAmC,EAAE,4BAA4B,EAAE,EAAE;;AAEzM;;gEAEgE;AAChE;;EAEE,eAAe;EACf,iBAAiB;EACjB,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,0CAA0C;EAC1C,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,iBAAiB,qBAAqB,EAAE;AACxC,+BAA+B,0BAA0B,EAAE,4BAA4B,EAAE;AACzF,4BAA4B,kCAAkC,EAAE;;AAEhE,sEAAsE;AACtE;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA,+BAA+B,yBAAyB,EAAE;;AAE1D,+EAA+E;;AAE/E;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,2CAA2C;EAC3C,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,kCAAkC,kCAAkC,EAAE;AACtE,sBAAsB,gCAAgC,EAAE,eAAe,EAAE;AACzE,kBAAkB,WAAW,EAAE,UAAU,EAAE;AAC3C,mGAAmG;AACnG,cAAc,qBAAqB,EAAE,sBAAsB,EAAE;;AAE7D,+EAA+E;AAC/E;;;EAGE,6BAA6B;EAC7B,2CAA2C;AAC7C;;AAEA;;qEAEqE;AACrE,sBAAsB,gBAAgB,EAAE;AACxC,kBAAkB,gBAAgB,EAAE,sBAAsB,EAAE;AAC5D,oCAAoC,gBAAgB,EAAE;;AAEtD,uEAAuE;AACvE;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA,sBAAsB,gCAAgC,EAAE;;AAExD;0BAC0B;AAC1B;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,qBAAqB,eAAe,EAAE;AACtC,gBAAgB,kBAAkB,EAAE;AACpC,+BAA+B,gBAAgB,EAAE;;AAEjD,qDAAqD;AACrD;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA,YAAY,yBAAyB,EAAE,gBAAgB,EAAE;;AAEzD,+EAA+E;;AAE/E;EACE,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,0BAA0B;AAC5B;;AAEA,0BAA0B,yBAAyB,EAAE;AACrD,6BAA6B,sBAAsB,EAAE,gBAAgB,EAAE;;AAEvE;;;;EAIE,eAAe;EACf,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA,oBAAoB,yBAAyB,EAAE,gBAAgB,EAAE;AACjE,gBAAgB,yBAAyB,EAAE;AAC3C,kBAAkB,yBAAyB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AAC7G,oBAAoB,iBAAiB,EAAE,gBAAgB,EAAE;;AAEzD,+EAA+E;;AAE/E;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,kFAAkF;EAClF,mDAAmD;EACnD,gBAAgB;EAChB,wBAAwB;EACxB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;;;;;uEAKuE;AACvE,8CAA8C,kBAAkB,EAAE;AAClE;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO,EAAE,+EAA+E;EACxF,mBAAmB;EACnB,oBAAoB;AACtB;AACA,iBAAiB,kBAAkB,EAAE;AACrC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,SAAS;AACX;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;EAC3B,8BAA8B;AAChC;AACA,oFAAoF;AACpF;EACE,kBAAkB,aAAa,EAAE;AACnC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,uEAAuE;AACvE;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,0CAA0C;EAC1C,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA,wBAAwB,yBAAyB,EAAE;AACnD,wCAAwC,0BAA0B,EAAE,8BAA8B,EAAE,4BAA4B,EAAE;AAClI,6CAA6C,sBAAsB,EAAE;AACrE,uBAAuB,0BAA0B,EAAE,eAAe,EAAE;;AAEpE;;;;;;EAME;AACF,cAAc,kBAAkB,EAAE,kBAAkB,EAAE;AACtD;;EAEE,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;AACZ;AACA,+EAA+E;AAC/E;EACE,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,2FAA2F;EAC3F,yBAAyB;EACzB,2BAA2B;EAC3B,2EAA2E;AAC7E;AACA;;2CAE2C;AAC3C;EACE,aAAa;EACb,WAAW;EACX,8JAA8J;EAC9J,yBAAyB;EACzB,4BAA4B;AAC9B;AACA,0BAA0B,0CAA0C,EAAE;AACtE,gCAAgC,gEAAgE,EAAE;AAClG,iCAAiC,gEAAgE,EAAE;AACnG,mCAAmC,iEAAiE,EAAE;AACtG;EACE,0CAA0C,gEAAgE,EAAE;EAC5G,2CAA2C,gEAAgE,EAAE;AAC/G;AACA;EACE,KAAK,UAAU,EAAE,2BAA2B,EAAE;EAC9C,MAAM,UAAU,EAAE;EAClB,MAAM,UAAU,EAAE;EAClB,OAAO,UAAU,EAAE,2BAA2B,EAAE;AAClD;AACA;EACE,KAAK,UAAU,EAAE,4BAA4B,EAAE;EAC/C,MAAM,UAAU,EAAE;EAClB,MAAM,UAAU,EAAE;EAClB,OAAO,UAAU,EAAE,2BAA2B,EAAE;AAClD;AACA;EACE,WAAW,yBAAyB,EAAE,eAAe,EAAE;EACvD,WAAW,sBAAsB,EAAE,0BAA0B,EAAE;AACjE;AACA;EACE;;qCAEmC,0BAA0B,EAAE;AACjE;;AAEA,6DAA6D;AAC7D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,6BAA6B;EAC7B,oBAAoB,EAAE,oCAAoC;EAC1D,gBAAgB;AAClB;AACA,yCAAyC,sBAAsB,EAAE;AACjE,8CAA8C,0BAA0B,EAAE,8BAA8B,EAAE,4BAA4B,EAAE;AACxI,oDAAoD,yBAAyB,EAAE,+BAA+B,EAAE;AAChH,6BAA6B,0BAA0B,EAAE,eAAe,EAAE;AAC1E,0CAA0C,8BAA8B,2BAA2B,EAAE,EAAE;;AAEvG;;;6EAG6E;AAC7E,sBAAsB,gBAAgB,EAAE;AACxC,wCAAwC,UAAU,EAAE,gBAAgB,EAAE;AACtE,iCAAiC,UAAU,EAAE,iBAAiB,EAAE,iBAAiB,EAAE;AACnF;qCACqC,aAAa,EAAE;AACpD,kCAAkC,gBAAgB,EAAE,kBAAkB,EAAE;AACxE,uCAAuC,iBAAiB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;AAClG,mCAAmC,cAAc,EAAE,iBAAiB,EAAE;AACtE,gDAAgD,aAAa,EAAE;AAC/D,mEAAmE;AACnE,wDAAwD,uBAAuB,EAAE,UAAU,EAAE;AAC7F,8DAA8D,mBAAmB,EAAE,oBAAoB,EAAE;AACzG;EACE,UAAU;EACV,mBAAmB;EACnB,6DAA6D;AAC/D;AACA,yBAAyB,gBAAgB,EAAE;AAC3C,2BAA2B,gBAAgB,EAAE,kBAAkB,EAAE;AACjE;wEACwE;AACxE,6BAA6B,gBAAgB,EAAE,kBAAkB,EAAE;AACnE,4CAA4C,gBAAgB,EAAE;;AAE9D;;;;;;;;;;;;;;;;;;;;;;8DAsB8D;AAC9D;;;;;;;;;;EAUE,UAAU;EACV,oBAAoB;AACtB;AACA,sEAAsE,0DAA0D,EAAE;AAClI;;;wEAGwE,8DAA8D,EAAE;AACxI;;4EAE4E,0DAA0D,EAAE;AACxI;;2EAE2E;AAC3E;0FAC0F,wDAAwD,EAAE;AACpJ;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;AACA,yEAAyE;AACzE,sDAAsD,eAAe,EAAE;AACvE;YACY;AACZ,0BAA0B,wCAAwC,EAAE;;AAEpE;;;;;sDAKsD;AACtD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,6EAA6E;AAC/E;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,8JAA8J;EAC9J,yBAAyB;EACzB,4BAA4B;EAC5B,UAAU;EACV,6EAA6E;AAC/E;AACA,0BAA0B,2BAA2B,EAAE;AACvD;EACE,WAAW,yBAAyB,EAAE,uCAAuC,EAAE;EAC/E,WAAW,sBAAsB,EAAE,6BAA6B,EAAE;AACpE;AACA;EACE,KAAK,UAAU,EAAE,4BAA4B,EAAE;EAC/C,MAAM,UAAU,EAAE;EAClB,MAAM,UAAU,EAAE;EAClB,OAAO,UAAU,EAAE,2BAA2B,EAAE;AAClD;AACA;EACE;uDACqD,0BAA0B,EAAE;AACnF;;AAEA,oEAAoE;AACpE;EACE,kBAAkB;AACpB;;AAEA,iFAAiF;;AAEjF;yCACyC;AACzC;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,oBAAoB;EACpB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,gCAAgC,gBAAgB,EAAE;AAClD,gCAAgC,gBAAgB,EAAE;;AAElD;;0EAE0E;AAC1E;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,+EAA+E;;AAE/E;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,mCAAmC;EACnC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA,kBAAkB,sBAAsB,EAAE,gBAAgB,EAAE;;AAE5D;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA,gFAAgF;;AAEhF;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,+BAA+B;EAC/B,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,sBAAsB,gBAAgB,EAAE;AACxC,kCAAkC,gBAAgB,EAAE;;AAEpD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,iFAAiF;;AAEjF;EACE,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,2CAA2C;EAC3C,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,wBAAwB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AAC1F,eAAe,mBAAmB,EAAE;AACpC,mCAAmC,gBAAgB,EAAE,gBAAgB,EAAE;;AAEvE;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA,gBAAgB,gBAAgB,EAAE;;AAElC;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,sBAAsB,sBAAsB,EAAE;AAC9C,yBAAyB,eAAe,EAAE;AAC1C,6EAA6E;AAC7E;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;AAC7B;AACA,eAAe,sBAAsB,EAAE;AACvC,eAAe,gBAAgB,EAAE;;AAEjC,iFAAiF;;AAEjF;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA,iBAAiB,kCAAkC,EAAE;;AAErD,gFAAgF;;AAEhF;;EAEE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,2DAA2D;EAC3D,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,2FAA2F;AAC3F,gBAAgB,sBAAsB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;;AAE/E;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA,iBAAiB,oBAAoB,EAAE;;AAEvC;EACE,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,uBAAuB,yBAAyB,EAAE;;AAElD;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA,qBAAqB,8BAA8B,EAAE;;AAErD,iFAAiF;;AAEjF;EACE,cAAc;EACd,4DAA4D;EAC5D,2BAA2B;AAC7B;;AAEA;;;aAGa;AACb;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,wCAAwC,gBAAgB,EAAE;;AAE1D,WAAW,aAAa,EAAE,sBAAsB,EAAE;;AAElD;;;;;;;;;;oCAUoC;;AAEpC;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,2CAA2C;EAC3C,gCAAgC;EAChC,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,oDAAoD;AACtD;;AAEA,0BAA0B,UAAU,EAAE,yBAAyB,EAAE;AACjE,sBAAsB,kCAAkC,EAAE;;AAE1D;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,+BAA+B;EAC/B,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,gDAAgD;AAClD;;AAEA,oBAAoB,cAAc,EAAE;AACpC,oBAAoB,eAAe,EAAE;;AAErC;;;+DAG+D;AAC/D,uBAAuB,aAAa,EAAE,sBAAsB,EAAE;AAC9D,mCAAmC,SAAS,EAAE;AAC9C,2CAA2C,SAAS,EAAE;;AAEtD;EACE,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,6BAA6B;EAC7B,sCAAsC;EACtC,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,yBAAyB,mBAAmB,EAAE;AAC9C,wBAAwB,oBAAoB,EAAE;;AAE9C,wDAAwD;AACxD;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,yBAAyB,kCAAkC,EAAE,sBAAsB,EAAE;;AAErF;qCACqC;AACrC;EACE,mCAAmC,qBAAqB,EAAE,aAAa,EAAE;AAC3E;;AAEA;EACE,gBAAgB,eAAe,EAAE;AACnC;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,mEAAmE;EACnE,+BAA+B;EAC/B,2CAA2C;EAC3C,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,2CAA2C;AAC7C;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB,EAAE,oCAAoC;EAC1D,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,+BAA+B;AACjC;;AAEA,6BAA6B,aAAa,EAAE,gBAAgB,EAAE,SAAS,EAAE;;AAEzE;;uBAEuB;AACvB;EACE,yBAAyB;EACzB;wFACsF;EACtF,8BAA8B;EAC9B,kBAAkB;EAClB;2CACyC;EACzC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,gCAAgC,UAAU,EAAE,sBAAsB,EAAE;;AAEpE;;;;;;;2BAO2B;AAC3B;EACE,iBAAiB;EACjB,oCAAoC;AACtC;AACA,mDAAmD,6BAA6B,EAAE,gBAAgB,EAAE;AACpG;EACE,6EAA6E;AAC/E;AACA;;6CAE6C,kBAAkB,EAAE;AACjE,wCAAwC,YAAY,EAAE,EAAE,uCAAuC;AAC/F;;2EAE2E;AAC3E;EACE;IACE,eAAe;IACf,yBAAyB;IACzB,UAAU;IACV,2BAA2B,EAAE,sCAAsC;EACrE;EACA,kCAAkC,cAAc,EAAE,wBAAwB,EAAE;EAC5E,yCAAyC,kBAAkB,EAAE;EAC7D,wCAAwC,WAAW,EAAE,YAAY,EAAE;EACnE;;;+DAG6D;EAC7D;IACE,+CAA+C,mBAAmB,EAAE;IACpE,oDAAoD,8BAA8B,EAAE;EACtF;AACF;AACA,2CAA2C;AAC3C;EACE;;+CAE6C,oBAAoB,EAAE;AACrE;;AAEA;;;;;;;;iCAQiC;AACjC;EACE,kBAAkB;EAClB,UAAU;EACV,4CAA4C;EAC5C,mCAAmC;EACnC,2BAA2B;EAC3B,oBAAoB,EAAE,oBAAoB;EAC1C,8BAA8B;EAC9B,oBAAoB;AACtB;AACA,4BAA4B,kBAAkB,EAAE;AAChD;EACE,kFAAkF;AACpF;AACA;EACE,KAAK,UAAU,EAAE;EACjB,MAAM,UAAU,EAAE;AACpB;AACA;EACE,8BAA8B,eAAe,EAAE;AACjD;AACA,8EAA8E;AAC9E;EACE,mBAAmB,yBAAyB,EAAE,sBAAsB,EAAE;AACxE;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA,oCAAoC,kCAAkC,EAAE,sBAAsB,EAAE;AAChG,wBAAwB,eAAe,EAAE,gCAAgC,EAAE;;AAE3E;uEACuE;AACvE;;;EAGE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;;;;2CAI2C;AAC3C;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;AACA,oBAAoB,yDAAyD,EAAE;AAC/E;EACE,oBAAoB,gBAAgB,EAAE;AACxC;;AAEA;;;6EAG6E;AAC7E;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;AACA,6CAA6C,yBAAyB,EAAE;;AAExE,wBAAwB,YAAY,EAAE;;AAEtC,uEAAuE;AACvE;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY,EAAE,6BAA6B;EAC3C,WAAW;EACX,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,2BAA2B;EAC3B,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,yBAAyB,eAAe,EAAE,YAAY,EAAE;AAC1D;;AAEA;;iEAEiE;AACjE;EACE,aAAa;EACb,uBAAuB;EACvB,uGAAuG;AACzG;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gEAAgE;EAChE,cAAc;EACd,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;;;oEAIoE;AACpE,oCAAoC,uBAAuB,EAAE,UAAU,EAAE;AACzE,0CAA0C,kBAAkB,EAAE,iCAAiC,EAAE;;AAEjG;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;iCACiC;AACjC;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,2CAA2C;EAC3C,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,2BAA2B,oDAAoD,EAAE;AACjF,0BAA0B,oDAAoD,EAAE,iBAAiB,EAAE;AACnG,qBAAqB,sBAAsB,EAAE;;AAE7C;EACE,kBAAkB;EAClB,UAAU;EACV,6BAA6B;EAC7B,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,2CAA2C;EAC3C,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,sCAAsC,kCAAkC,EAAE;AAC1E,iBAAiB,yBAAyB,EAAE,+BAA+B,EAAE;AAC7E,iBAAiB,yBAAyB,EAAE;AAC5C,oBAAoB,sBAAsB,EAAE;AAC5C,oBAAoB,gCAAgC,EAAE;;AAEtD;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;oCAEoC;AACpC;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA,sBAAsB,cAAc,EAAE;AACtC,mBAAmB,cAAc,EAAE,0BAA0B,EAAE,0BAA0B,EAAE;;AAE3F;EACE;IACE,aAAa;EACf;AACF;;AAEA,iFAAiF;;AAEjF;EACE,aAAa;EACb,+BAA+B;EAC/B,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;4BAC4B,gBAAgB,EAAE;;AAE9C,kEAAkE;AAClE,yBAAyB,gBAAgB,EAAE;;AAE3C;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA,wDAAwD;AACxD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA,kFAAkF;;AAElF;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,6DAA6D;EAC7D,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA,mBAAmB,OAAO,EAAE,YAAY,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;;AAE3F;EACE,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,mBAAmB,sBAAsB,EAAE;;AAE3C;EACE,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;EACrB,+BAA+B;EAC/B,2CAA2C;EAC3C,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,iBAAiB,kCAAkC,EAAE;AACrD,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;;AAEjE,sCAAsC;AACtC,cAAc,kBAAkB,EAAE;;AAElC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,2CAA2C;EAC3C,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,wBAAwB,kCAAkC,EAAE;AAC5D,4DAA4D,yBAAyB,EAAE;;AAEvF;EACE,kBAAkB;EAClB,qBAAqB;EACrB;6EAC2E;EAC3E,QAAQ;EACR,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,yBAAyB,kCAAkC,EAAE,qBAAqB,EAAE;AACpF,sBAAsB,eAAe,EAAE,yBAAyB,EAAE,gBAAgB,EAAE,kCAAkC,EAAE;AACxH,sBAAsB,iBAAiB,EAAE,mBAAmB,EAAE,oBAAoB,EAAE,yBAAyB,EAAE;;AAE/G,cAAc,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,oBAAoB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,kCAAkC,EAAE;AAC7K,kBAAkB,WAAW,EAAE,WAAW,EAAE,kBAAkB,EAAE,2CAA2C,EAAE,gBAAgB,EAAE;AAC/H,mBAAmB,YAAY,EAAE,2BAA2B,EAAE;;AAE9D,kFAAkF;;AAElF;EACE,aAAa,iBAAiB,EAAE;EAChC,eAAe,8BAA8B,EAAE;EAC/C,cAAc,eAAe,EAAE;EAC/B,+BAA+B,aAAa,EAAE;EAC9C,WAAW,WAAW,EAAE,YAAY,EAAE;EACtC,oBAAoB,sBAAsB,EAAE,oBAAoB,EAAE;EAClE,6BAA6B,WAAW,EAAE;EAC1C,2BAA2B,cAAc,EAAE;AAC7C;;AAEA;EACE,eAAe,0BAA0B,EAAE;EAC3C,eAAe,eAAe,EAAE;EAChC,aAAa,eAAe,EAAE;AAChC;;AAEA;;0DAE0D;AAC1D;EACE,iBAAiB,aAAa,EAAE;EAChC,WAAW,eAAe,EAAE;EAC5B,aAAa,QAAQ,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;EAChE,kBAAkB,eAAe,EAAE;EACnC,qDAAqD,eAAe,EAAE;EACtE,yBAAyB,kBAAkB,EAAE;AAC/C;;AAEA;EACE;cACY,eAAe,EAAE;EAC7B;;;sCAGoC,gBAAgB,EAAE;AACxD;;AAEA,oFAAoF;AACpF;EACE,iBAAiB,kBAAkB,EAAE;AACvC","sourcesContent":["/*\n * ChatView: the one chat surface (Open Search, Focused Study multi/single),\n * set like a printed interview (BRAND_SPEC §11.1). No bubbles: a person's\n * words in Newsreader, AI Rob's in Inter, a label over every turn. Single\n * column, 20 px sides, 680 px at most; every control at least 44 px.\n */\n\n.chat-view {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  height: 100%;\n  position: relative;\n  color: var(--brand-fg);\n  background: var(--brand-bg);\n}\n\n.cv-column {\n  width: 100%;\n  max-width: calc(var(--column-chat) + 40px);\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n/* A mode header (Focused Study) slides up by its measured height while a\n   conversation is read on a phone; .shell-content clips it on the way out.\n   ChatView sets --cv-header-h and the .tucked class. */\n.cv-header-slot {\n  flex-shrink: 0;\n  transition:\n    margin-top var(--dur-base) var(--ease-out),\n    opacity var(--dur-fast) var(--ease-out),\n    visibility 0s linear 0s;\n}\n\n.chat-view.tucked .cv-header-slot {\n  margin-top: calc(-1 * var(--cv-header-h, 56px));\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition:\n    margin-top var(--dur-base) var(--ease-out),\n    opacity var(--dur-fast) var(--ease-out),\n    visibility 0s linear var(--dur-base);\n}\n\n/* ---- the conversation -------------------------------------------------- */\n\n.cv-messages-wrap {\n  flex: 1;\n  min-height: 0;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n\n.cv-scroll {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n  padding: 18px 0 12px;\n  scroll-padding-bottom: 24px;\n}\n\n.cv-end { height: 1px; }\n\n/* Room after a short answer so its question can sit at the top of the\n   screen; ChatView sizes it (0 whenever nothing is parked). */\n.cv-tail-space { height: 0; pointer-events: none; }\n\n.cv-msg {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n\n/* Labels: Inter 600 13 px, sentence case, --brand-muted (§6.4). */\n.cv-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.8125rem;\n  line-height: 1.35;\n  font-weight: 600;\n  color: var(--brand-muted);\n}\n\n.cv-label .apr-mark {\n  flex: none;\n  display: block;\n  color: var(--brand-fg);\n}\n\n/* A person's words: the serif (§6.2). The first question is the heading. */\n.cv-msg.user {\n  margin: 30px 0 14px;\n}\n\n.cv-column > .cv-msg.user:first-of-type,\n.cv-scroll .cv-msg.user:first-child {\n  margin-top: 0;\n}\n\n.cv-question {\n  margin: 8px 0 0;\n  font-family: var(--font-serif);\n  font-weight: 440;\n  color: var(--brand-fg);\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n  text-wrap: balance;\n}\n\n.cv-question.size-lead {\n  font-size: 1.9375rem;\n  line-height: 1.1;\n  letter-spacing: -0.012em;\n  font-variation-settings: \"opsz\" 36;\n}\n\n.cv-question.size-follow {\n  font-size: 1.5rem;\n  line-height: 1.17;\n  letter-spacing: -0.012em;\n  font-variation-settings: \"opsz\" 36;\n}\n\n.cv-question.size-long {\n  font-size: 1.1875rem;\n  line-height: 1.5;\n  font-weight: 400;\n  font-variation-settings: \"opsz\" 18;\n  text-wrap: pretty;\n}\n\n/* Arriving from an ad: the question parks as the heading (§9.5), transform\n   only. The children move, not the turn itself, so the view parks on the\n   turn's resting place. */\n.cv-msg.user.landing > * {\n  animation: cvPark var(--dur-base) var(--ease-out);\n}\n\n@keyframes cvPark {\n  from { transform: translateY(28px); }\n  to { transform: none; }\n}\n\n.cv-arrival {\n  margin: 10px 0 0;\n  font-size: 0.875rem;\n  line-height: 1.45;\n  color: var(--brand-muted);\n}\n\n.cv-arrival-edit {\n  display: inline-block;\n  min-height: 24px;\n  padding: 0;\n  font-weight: 600;\n  color: var(--brand-fg);\n  text-decoration-line: underline;\n  text-decoration-thickness: 1px;\n  text-underline-offset: 0.2em;\n}\n\n/* AI Rob's answers: Inter 400 17/27, --brand-fg-read, 66ch (§6.4). */\n.cv-msg.assistant {\n  margin: 24px 0 26px;\n}\n\n.cv-msg.user + .cv-msg.assistant,\n.cv-msg.user + .cv-msg.streaming {\n  margin-top: 22px;\n}\n\n.cv-answer {\n  margin-top: 8px;\n}\n\n/* A finished answer replaces its streaming twin in place: no second entrance. */\n.cv-msg.settled { animation: none; }\n\n/* Streamed words fade in, 200 ms, opacity only (§9.5). ChatView's\n   inkFreshText sets a negative delay so each word's fade survives the next\n   re-render. */\n.cv-fresh { animation: cvInk var(--stream-word-fade) ease-out both; }\n\n@keyframes cvInk {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n/* AI Rob's writing caret: grey, 2 px, solid, at the insertion point while the\n   answer streams, gone when it ends (§4, §9.2). */\n.cv-caret-ai {\n  display: inline-block;\n  width: 2px;\n  height: 1.15em;\n  margin-left: 2px;\n  vertical-align: -0.2em;\n  background: var(--brand-caret-ai);\n}\n\n.cv-msg.streaming .cv-markdown > :last-child:not(ul):not(ol)::after,\n.cv-msg.streaming .cv-markdown > :last-child > li:last-child::after {\n  content: '';\n  display: inline-block;\n  width: 2px;\n  height: 1.15em;\n  margin-left: 2px;\n  vertical-align: -0.2em;\n  background: var(--brand-caret-ai);\n}\n\n.cv-markdown {\n  max-width: var(--measure);\n  font-size: 1.0625rem;\n  line-height: 1.6;\n  color: var(--brand-fg-read);\n  overflow-wrap: break-word;\n  text-wrap: pretty;\n}\n\n.cv-markdown p { margin: 0 0 12px; color: inherit; }\n.cv-markdown p:last-child { margin-bottom: 0; }\n.cv-markdown h1,\n.cv-markdown h2,\n.cv-markdown h3 {\n  margin: 20px 0 8px;\n  font-family: var(--font-sans);\n  font-size: 1.125rem;\n  line-height: 1.35;\n  font-weight: 600;\n  color: var(--brand-fg);\n}\n.cv-markdown h1:first-child,\n.cv-markdown h2:first-child,\n.cv-markdown h3:first-child { margin-top: 0; }\n.cv-markdown ul,\n.cv-markdown ol { margin: 4px 0 14px; padding-left: 1.3em; }\n.cv-markdown li { margin: 6px 0; padding-left: 2px; }\n.cv-markdown li::marker { color: var(--brand-muted); }\n.cv-markdown li p { margin: 0; }\n.cv-markdown strong { color: var(--brand-fg); font-weight: 600; }\n/* No italics in running text (BDA, §6.5): emphasis is the brighter ink. */\n.cv-markdown em { font-style: normal; color: var(--brand-fg); }\n.cv-markdown hr { border: 0; border-top: 1px solid var(--brand-line); margin: 18px 0; }\n.cv-markdown code {\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-size: 0.88em;\n  padding: 0.1em 0.35em;\n  border-radius: var(--radius-sm);\n  background: var(--brand-surface-2);\n  color: var(--brand-fg);\n}\n.cv-markdown a {\n  color: var(--brand-fg);\n  text-decoration-line: underline;\n  text-decoration-thickness: 1px;\n  text-underline-offset: 0.2em;\n}\n.cv-markdown a:hover { text-decoration-thickness: 2px; }\n\n/* A quoted passage from a live answer: the sans, with a quiet rule. Serif\n   is only for words the server or Rob's approval has verified (§6.2). */\n.cv-markdown blockquote {\n  margin: 14px 0;\n  padding: 2px 0 2px 14px;\n  border-left: 2px solid var(--brand-line-control);\n  color: var(--brand-fg-read);\n}\n\n/* Rob's verbatim words (a Rob-approved answer): Newsreader roman, opsz 18,\n   18/26, white, the 2 px rule, curly quotes in the text itself. */\n.cv-markdown blockquote.cv-verbatim,\n.cv-markdown .cv-verbatim {\n  font-family: var(--font-serif);\n  font-weight: 400;\n  font-variation-settings: \"opsz\" 18;\n  font-size: 1.125rem;\n  line-height: 1.45;\n  color: var(--brand-fg);\n}\n\n/* Citations (utils/sermonTimestampLinks.js): the name stays in the sentence,\n   in the sentence's own style; a small number after it is the link. */\n.cv-markdown .cv-cite-name { font-style: normal; }\n.cv-markdown .cv-cite {\n  font-family: var(--font-sans);\n  font-size: 0.75rem;\n  font-style: normal;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  line-height: 0; /* never pushes its line away from the next */\n  vertical-align: 0.5em;\n  margin-left: 0.15em;\n}\n/* Numbers back to back read \"¹,²\". Which ones touch is decided where they are\n   placed (cv-cite-more): a sibling selector cannot see the sentence between\n   two numbers in one paragraph, and would put a comma there too. */\n.cv-markdown .cv-cite-more::before { content: ','; color: var(--brand-muted); }\n/* The padding gives the hover wash room; the matching negative margin keeps\n   the number against its word and the comma or period after it. */\n.cv-markdown .cv-cite a,\n.cv-markdown .cv-cite .cv-cite-num {\n  padding: 0.25em 0.2em;\n  margin: 0 -0.2em;\n  border-radius: 4px;\n  color: var(--brand-fg);\n  text-decoration-line: underline;\n  text-decoration-thickness: 1px;\n  text-underline-offset: 2px;\n}\n.cv-markdown .cv-cite .cv-cite-num { color: var(--brand-muted); text-decoration: none; cursor: default; }\n.cv-markdown .cv-cite a:hover { background: var(--brand-surface-2); }\n/* What a screen reader says for a number that links nowhere (the book). */\n.cv-markdown .cv-cite-sr {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  border: 0;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  white-space: nowrap;\n  user-select: none;\n}\n\n/* Fingers: a superscript stays small but takes a finger-sized tap (24 x 24\n   or more, WCAG 2.2 SC 2.5.8), and each source row fills its width. */\n@media (hover: none) {\n  .cv-markdown .cv-cite a { position: relative; }\n  .cv-markdown .cv-cite a::after { content: ''; position: absolute; inset: -12px -9px; }\n  /* Back to back, each number keeps its own side of the comma: the later one\n     no longer reaches left over the earlier, nor the earlier right over it. */\n  .cv-markdown .cv-cite-more a::after { left: 0; }\n  .cv-markdown .cv-cite:has(+ .cv-cite-more) a::after { right: 0; }\n}\n\n/* Pointers: the same 24 px target, as padding around the number. */\n@media (hover: hover) {\n  .cv-markdown .cv-cite a {\n    display: inline-block;\n    min-width: 1.2em;\n    padding: 0.5em 0.3em;\n    margin: -0.5em -0.3em;\n    text-align: center;\n  }\n}\n\n/* Bible references (utils/scripture.js): a tap opens the passage. At rest\n   one looks exactly like the words around it, its colour, face and weight\n   inherited, in bold too (§6.5's one exception to \"links keep their\n   underline\"); a brief wash while pressed, the hand and the link's line\n   under a mouse, the global ring for the keyboard, no transitions. It wraps\n   like the words around it, so no size of text pushes the answer sideways;\n   a tap on either line opens it. data-scripture=\"hint\" (scriptureLinks 2)\n   adds a faint dotted line. */\n.cv-markdown .cv-scripture { cursor: pointer; border-radius: 3px; -webkit-tap-highlight-color: transparent; }\n.cv-markdown .cv-scripture:active { background: var(--brand-surface-2); }\n.cv-markdown .cv-scripture:focus-visible { color: var(--brand-fg); }\n.chat-view[data-scripture=\"hint\"] .cv-markdown .cv-scripture { text-decoration: underline dotted 1px; text-underline-offset: 0.25em; text-decoration-color: var(--brand-line-control); }\n@media (hover: hover) { .chat-view .cv-markdown .cv-scripture:hover { color: var(--brand-fg); text-decoration: underline solid 1px; text-decoration-color: currentColor; text-underline-offset: 0.2em; } }\n\n/* ---- sources: \"From Rob's sermons\" (§11.1) ------------------------------\n   The cited list (renderSourceRows) and, for an answer that cites nothing,\n   the sermons it drew on (.cv-sources). Each row is one link. */\n.cv-cites,\n.cv-sources {\n  margin: 0 0 4px;\n  padding-top: 14px;\n  border-top: 1px solid var(--brand-line);\n  max-width: var(--measure);\n}\n\n.cv-cites-label,\n.cv-sources-label {\n  display: block;\n  margin-bottom: 2px;\n  font-size: 0.8125rem;\n  line-height: 1.35;\n  font-weight: 600;\n  color: var(--brand-muted);\n}\n\n.cv-cites-list,\n.cv-src-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.cv-src {\n  display: grid;\n  grid-template-columns: 24px minmax(0, 1fr) 40px;\n  align-items: center;\n  gap: 12px;\n  min-height: 60px;\n  padding: 10px 0;\n  border-bottom: 1px solid var(--brand-line);\n  color: var(--brand-fg);\n  text-decoration: none;\n  border-radius: 2px;\n  transition: outline-color var(--dur-fast) var(--ease-out);\n}\n\n.cv-src-list .cv-src {\n  grid-template-columns: 24px minmax(0, 1fr);\n}\n\na.cv-src:hover { text-decoration: none; }\na.cv-src:hover .cv-src-title { text-decoration: underline; text-underline-offset: 0.2em; }\na.cv-src:hover .cv-src-go { background: var(--brand-surface-2); }\n\n/* A citation tap lands here: a 2 px white outline for 1.2 s (§9.5). */\n.cv-src.is-flash {\n  outline: 2px solid var(--brand-fg);\n  outline-offset: 2px;\n}\n\n.cv-src-n {\n  display: grid;\n  place-items: center;\n  width: 24px;\n  height: 24px;\n  border: 1px solid var(--brand-line-control);\n  border-radius: var(--radius-sm);\n  font-size: 0.75rem;\n  font-weight: 600;\n  line-height: 1;\n  font-variant-numeric: tabular-nums;\n  color: var(--brand-fg);\n}\n\n.cv-src-text {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.cv-src-title {\n  font-size: 0.9375rem;\n  line-height: 1.3;\n  font-weight: 500;\n  color: var(--brand-fg);\n  overflow-wrap: anywhere;\n}\n\n.cv-src-meta {\n  margin-top: 2px;\n  font-size: 0.8125rem;\n  line-height: 1.4;\n  color: var(--brand-muted);\n  font-variant-numeric: tabular-nums;\n}\n\n.cv-src-go {\n  display: grid;\n  place-items: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 1px solid var(--brand-line-control);\n  color: var(--brand-muted);\n}\n\n.cv-src.is-static .cv-src-go { border-color: transparent; }\n\n/* ---- actions under an answer (quiet, 44 px) ------------------------------ */\n\n.cv-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  margin: 16px 0 18px;\n}\n\n.cv-action {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  min-width: 44px;\n  min-height: 44px;\n  padding: 0 12px;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--brand-line-control);\n  background: transparent;\n  color: var(--brand-fg);\n  font-size: 0.875rem;\n  font-weight: 600;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.cv-action small {\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: var(--brand-muted);\n}\n\n.cv-action:hover:not(:disabled) { background: var(--brand-surface-2); }\n.cv-action:disabled { color: var(--brand-line-control); cursor: default; }\n.cv-action.icon { width: 44px; padding: 0; }\n/* \"Fix in Zed\" (owners and admins only) is a link to the portal, drawn as the buttons beside it. */\na.cv-action { text-decoration: none; box-sizing: border-box; }\n\n/* Chosen (a thumb, \"Sent to Rob\", playing): a 2 px white edge, never a fill. */\n.cv-action.chosen,\n.cv-action.playing,\n.cv-action.loading {\n  border-color: var(--brand-fg);\n  box-shadow: inset 0 0 0 1px var(--brand-fg);\n}\n\n/* First Answer's More (ChatParts MoreAnswer): under a short first answer and\n   before its actions, the one next step it offers. The brand's line button\n   (.apr-btn, 48 px, a 2 px edge in the text colour, never a fill). */\n.cv-more-answer-row { margin: 16px 0 0; }\n.cv-more-answer { min-width: 132px; padding: 0 16px 0 20px; }\n.cv-more-answer-row + .cv-actions { margin-top: 12px; }\n\n/* \"Fast answer · 6.1 s · Go deeper\": a quiet line under the actions. */\n.cv-answer-meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  margin: -10px 0 18px 2px;\n  font-size: 0.8125rem;\n  line-height: 1.4;\n  color: var(--brand-subtle);\n  font-variant-numeric: tabular-nums;\n}\n\n.cv-answer-meta > span[aria-hidden] {\n  white-space: pre;\n}\n\n.cv-deeper {\n  min-height: 44px;\n  padding: 0;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: var(--brand-fg);\n  text-decoration-line: underline;\n  text-decoration-thickness: 1px;\n  text-underline-offset: 0.2em;\n}\n\n.cv-deeper:disabled { color: var(--brand-line-control); }\n\n/* Notes from the app itself (stopped, cut off, the 3-hour reminder): not an\n   AI turn, so no label. */\n.cv-note {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin: 0;\n  max-width: var(--measure);\n  font-size: 0.9375rem;\n  line-height: 1.5;\n  color: var(--brand-muted);\n}\n\n.cv-note .apr-icon { margin-top: 3px; }\n.cv-msg.local { margin: 8px 0 22px; }\n.cv-msg.assistant > .cv-note { margin-top: 12px; }\n\n/* The answer in flight: its running time, quietly. */\n.cv-stream-footer {\n  display: flex;\n  gap: 10px;\n  align-items: baseline;\n  margin-top: 10px;\n  font-size: 0.8125rem;\n  color: var(--brand-subtle);\n  font-variant-numeric: tabular-nums;\n}\n\n.cv-timer { color: var(--brand-muted); font-weight: 500; }\n\n/* ---- thinking (§9.5): one status line and the grey caret, solid ---------- */\n\n.thinking-card {\n  margin-top: 8px;\n  font-size: 0.8125rem;\n  line-height: 1.45;\n}\n\n.thinking-status {\n  margin: 0;\n  font-weight: 500;\n  color: var(--brand-muted);\n}\n\n.thinking-steps {\n  display: flex;\n  flex-wrap: wrap;\n  list-style: none;\n  margin: 6px 0 0;\n  padding: 0;\n  color: var(--brand-subtle);\n  font-weight: 500;\n}\n\n.thinking-steps li + li::before {\n  content: '·';\n  margin: 0 6px;\n  color: var(--brand-subtle);\n}\n\n.thinking-steps li.done { color: var(--brand-muted); }\n.thinking-steps li.current { color: var(--brand-fg); font-weight: 600; }\n\n.thinking-meta,\n.thinking-sub,\n.thinking-found,\n.thinking-thought {\n  margin: 4px 0 0;\n  color: var(--brand-subtle);\n  font-variant-numeric: tabular-nums;\n}\n\n.thinking-elapsed { color: var(--brand-muted); font-weight: 500; }\n.thinking-sub { color: var(--brand-muted); }\n.thinking-found { color: var(--brand-muted); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }\n.thinking-thought { max-height: 4.4em; overflow: hidden; }\n\n/* ---- the welcome screen (no campaign) ------------------------------------ */\n\n.cv-welcome {\n  margin: 6vh 0 24px;\n}\n\n.cv-welcome-title {\n  position: relative;\n  margin: 0;\n  font-family: var(--font-serif);\n  font-weight: 440;\n  /* A size up (Alexi, Oct 17): about 36 px on a phone, up to 44 px on a computer. */\n  font-size: clamp(2.25rem, 1.95rem + 1.4vw, 2.75rem);\n  line-height: 1.1;\n  letter-spacing: -0.012em;\n  font-variation-settings: \"opsz\" 36;\n  color: var(--brand-fg);\n}\n\n/* \"Ask anything.\" typing (WelcomeTitle, §9.1): the words stay in place,\n   transparent, under an aria-hidden copy that shows them a character at a\n   time with the caret after them. The caret is a point on the baseline that\n   draws the bar (so it takes no room, not even in the line's height) and the\n   rest of the copy is laid out but unseen: the copy lies exactly on the words\n   and nothing moves when it goes. The caret is solid while it types. */\n.cv-welcome-title.is-typing .cv-title-words { color: transparent; }\n.cv-title-typed {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0; /* not `inset`: an older phone without it would set the copy beside the words */\n  white-space: nowrap;\n  pointer-events: none;\n}\n.cv-title-rest { visibility: hidden; }\n.cv-title-caret {\n  position: relative;\n  display: inline-block;\n  width: 0;\n  height: 0;\n}\n.cv-title-caret::after {\n  content: '';\n  position: absolute;\n  left: var(--caret-gap);\n  bottom: calc(-1 * var(--caret-drop));\n  width: var(--caret-width);\n  height: var(--caret-height);\n  background: var(--brand-caret);\n}\n/* High-contrast modes repaint every colour, transparent included: just the words. */\n@media (forced-colors: active) {\n  .cv-title-typed { display: none; }\n}\n\n.cv-welcome-text {\n  margin: 12px 0 0;\n  max-width: 34em;\n  font-size: 1.0625rem;\n  line-height: 1.6;\n  color: var(--brand-fg-read);\n}\n\n/* Starter questions: rows of a person's words, one tap each (§11.1). */\n.cv-starters {\n  list-style: none;\n  margin: 28px 0 0;\n  padding: 0;\n  border-top: 1px solid var(--brand-line);\n}\n\n.cv-starter {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  width: 100%;\n  min-height: 60px;\n  padding: 14px 2px;\n  border-bottom: 1px solid var(--brand-line);\n  color: var(--brand-fg);\n  font-family: var(--font-serif);\n  font-weight: 440;\n  font-size: 1.25rem;\n  line-height: 1.25;\n  font-variation-settings: \"opsz\" 24;\n  text-align: left;\n}\n\n.cv-starter .apr-icon { color: var(--brand-muted); }\n.cv-starter:hover:not(:disabled) span { text-decoration: underline; text-decoration-thickness: 1px; text-underline-offset: 0.2em; }\n.cv-starter:hover:not(:disabled) .apr-icon { color: var(--brand-fg); }\n.cv-starter:disabled { color: var(--brand-subtle); cursor: default; }\n\n/*\n * The glimmer (utils/starterGlimmer.js): one row at a time, a band of light\n * runs along its rule, a faint sheen crosses the row, and the arrow brightens\n * and leans toward a tap. Monochrome like everything else (BRAND_SPEC: no\n * hue): the light is the text colour, so it reads in Night and Day. Hovering\n * a row plays it too, on a pointer that can hover. Never with reduced motion.\n */\n.cv-starter { position: relative; isolation: isolate; }\n.cv-starter::before,\n.cv-starter::after {\n  content: '';\n  position: absolute;\n  pointer-events: none;\n  opacity: 0;\n}\n/* The rule's light: a short bright band gliding along the row's bottom line. */\n.cv-starter::after {\n  left: 0;\n  right: 0;\n  bottom: -1px;\n  height: 1px;\n  background: linear-gradient(90deg, transparent, var(--brand-fg) 50%, transparent) no-repeat;\n  background-size: 38% 100%;\n  background-position: -60% 0;\n  box-shadow: 0 0 10px 0 color-mix(in srgb, var(--brand-fg) 35%, transparent);\n}\n/* The row's sheen: a soft diagonal wash of light, barely there. Light on\n   Night's black is the text colour; on Day's cream it is white (a dark wash\n   there reads as a smudge, not a sheen). */\n.cv-starter::before {\n  inset: 0 -2px;\n  z-index: -1;\n  background: linear-gradient(105deg, transparent 30%, var(--cv-sheen-face, color-mix(in srgb, var(--brand-fg) 7%, transparent)) 50%, transparent 70%) no-repeat;\n  background-size: 60% 100%;\n  background-position: -110% 0;\n}\n:root[data-theme=\"day\"] { --cv-sheen-face: rgba(255, 255, 255, 0.85); }\n.cv-starter.is-glimmer::after { animation: cv-sheen-rule 1.3s cubic-bezier(0.45, 0, 0.2, 1) both; }\n.cv-starter.is-glimmer::before { animation: cv-sheen-face 1.3s cubic-bezier(0.45, 0, 0.2, 1) both; }\n.cv-starter.is-glimmer .apr-icon { animation: cv-sheen-arrow 1.3s cubic-bezier(0.45, 0, 0.2, 1) both; }\n@media (hover: hover) and (pointer: fine) {\n  .cv-starter:hover:not(:disabled)::after { animation: cv-sheen-rule 1.1s cubic-bezier(0.45, 0, 0.2, 1) both; }\n  .cv-starter:hover:not(:disabled)::before { animation: cv-sheen-face 1.1s cubic-bezier(0.45, 0, 0.2, 1) both; }\n}\n@keyframes cv-sheen-rule {\n  0% { opacity: 0; background-position: -60% 0; }\n  14% { opacity: 1; }\n  86% { opacity: 1; }\n  100% { opacity: 0; background-position: 160% 0; }\n}\n@keyframes cv-sheen-face {\n  0% { opacity: 0; background-position: -110% 0; }\n  20% { opacity: 1; }\n  80% { opacity: 1; }\n  100% { opacity: 0; background-position: 210% 0; }\n}\n@keyframes cv-sheen-arrow {\n  0%, 100% { color: var(--brand-muted); transform: none; }\n  45%, 60% { color: var(--brand-fg); transform: translateX(3px); }\n}\n@media (prefers-reduced-motion: reduce) {\n  .cv-starter::before,\n  .cv-starter::after,\n  .cv-starter.is-glimmer .apr-icon { animation: none !important; }\n}\n\n/* \"More questions\": another four, quietly, under the list. */\n.cv-more-starters {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 44px;\n  margin-top: 6px;\n  padding: 0 2px;\n  color: var(--brand-muted);\n  font-family: var(--font-sans);\n  font-size: 1.0625rem; /* 17 px: words to read and act on */\n  font-weight: 500;\n}\n.cv-more-starters:hover:not(:disabled) { color: var(--brand-fg); }\n.cv-more-starters:hover:not(:disabled) span { text-decoration: underline; text-decoration-thickness: 1px; text-underline-offset: 0.2em; }\n.cv-more-starters:active:not(:disabled) .apr-icon { transform: rotate(180deg); transition: transform 0.3s ease; }\n.cv-more-starters:disabled { color: var(--brand-subtle); cursor: default; }\n@media (prefers-reduced-motion: reduce) { .cv-more-starters .apr-icon { transition: none !important; } }\n\n/* Nothing asked yet (team review, Oct 2026): the welcome, the box, then the\n   questions to start with and the fine print, centred together on the\n   screen; the whole view scrolls if a short screen can't hold them. The\n   first question takes .is-empty away and the box goes back to the bottom. */\n.chat-view.is-empty { overflow-y: auto; }\n.chat-view.is-empty .cv-messages-wrap { flex: none; margin-top: auto; }\n.chat-view.is-empty .cv-scroll { flex: none; overflow: visible; padding-bottom: 0; }\n.chat-view.is-empty .cv-end,\n.chat-view.is-empty .cv-tail-space { display: none; }\n.chat-view.is-empty .cv-welcome { margin: 0 0 22px; text-align: center; }\n.chat-view.is-empty .cv-welcome-text { margin-left: auto; margin-right: auto; text-wrap: balance; }\n.chat-view.is-empty .cv-composer { padding-top: 0; padding-bottom: 0; }\n.chat-view.is-empty .cv-form > .cv-disclaimer { display: none; }\n/* The toolbar stays open here; it only folds away while reading. */\n.chat-view.is-empty .cv-composer.collapsed .cv-chrome { grid-template-rows: 1fr; opacity: 1; }\n.chat-view.is-empty .cv-composer.collapsed .cv-chrome-inner { visibility: visible; transition-delay: 0s; }\n.cv-below {\n  flex: none;\n  margin-bottom: auto;\n  padding-bottom: calc(16px + env(safe-area-inset-bottom, 0px));\n}\n.cv-below .cv-starters { margin-top: 18px; }\n.cv-below .cv-disclaimer { margin-top: 14px; text-align: center; }\n/* The front page's line, under the box (ChatView lineBelowBox): \"Ask\n   anything.\" sits right over the box, and the line says what this is. */\n.cv-below .cv-welcome-text { margin-top: 16px; text-align: center; }\n.cv-below .cv-welcome-text + .cv-starters { margin-top: 22px; }\n\n/* The first view of a visit (ChatView REVEAL; Alexi, Oct 17, v2): the first\n   frame is \"Ask anything.\" typing over the box, and nothing else. The line\n   under the box fades in as the caret drops into it; at 4 s the four\n   questions, one by one (the first with the list's top rule); then the menu\n   (the desktop's rail, the phone's menu button) and More questions; then Ask\n   glimmers twice; last, slowly, the AI notice (its crisis link) and the fine\n   print. Opacity only: everything holds its place from the first frame, so\n   nothing moves. What isn't in yet can't be tapped, and a screen reader\n   still finds all of it, the AI notice from the first frame. The header's\n   lockup is never held back. ChatView sets these classes only while it\n   plays: without them (a repeat view, an ad's landing, a link with words,\n   a crisis hold, reduced motion, a high-contrast mode, no script at all)\n   everything is simply there. The menu and the AI notice live in the app's\n   shell, outside this view: they are held while this view holds them\n   (:has). A browser without :has never holds them, so the AI notice is\n   there from the first frame; and a notice still drawn see-through once the\n   reveal is over is made visible (ChatView noticeIn). Anyone starting takes\n   every class away at once, and the fades with them: the fades are\n   animations, which end the moment .is-revealing goes (a transition would\n   play on to its end). Each lasts as long as ChatView says\n   (REVEAL_STYLE sets --reveal-* on the page), and none outlasts it (no\n   fill): a finished fade left in place would keep Chrome from counting the\n   line as painted (Largest Contentful Paint) until the end. */\n.chat-view.holds-line .cv-below .cv-welcome-text,\n.chat-view.holds-q1 .cv-starters,\n.chat-view.holds-q2 .cv-starters > li:nth-child(2),\n.chat-view.holds-q3 .cv-starters > li:nth-child(3),\n.chat-view.holds-q4 .cv-starters > li:nth-child(4),\n.chat-view.holds-menu .cv-more-starters,\n.chat-view.holds-notice .cv-below .cv-disclaimer,\n.app-shell:has(.chat-view.holds-menu) .sidebar,\n.app-shell:has(.chat-view.holds-menu) .shell-hamburger,\n.app-shell:has(.chat-view.holds-notice) .ai-disclosure {\n  opacity: 0;\n  pointer-events: none;\n}\n.chat-view.is-revealing:not(.holds-line) .cv-below .cv-welcome-text { animation: cv-reveal-in var(--reveal-line) var(--ease-out); }\n.chat-view.is-revealing:not(.holds-q1) .cv-starters,\n.chat-view.is-revealing:not(.holds-q2) .cv-starters > li:nth-child(2),\n.chat-view.is-revealing:not(.holds-q3) .cv-starters > li:nth-child(3),\n.chat-view.is-revealing:not(.holds-q4) .cv-starters > li:nth-child(4) { animation: cv-reveal-in var(--reveal-question) var(--ease-out); }\n.chat-view.is-revealing:not(.holds-menu) .cv-more-starters,\n.app-shell:has(.chat-view.is-revealing:not(.holds-menu)) .sidebar,\n.app-shell:has(.chat-view.is-revealing:not(.holds-menu)) .shell-hamburger { animation: cv-reveal-in var(--reveal-menu) var(--ease-out); }\n/* Very slowly, and evenly: the notice's words are read, not noticed moving.\n   Only when it was held back (stages-notice: ChatView's\n   AI_NOTICE_NOT_BEFORE_MS at 0 never holds it, and then it never fades). */\n.chat-view.is-revealing.stages-notice:not(.holds-notice) .cv-below .cv-disclaimer,\n.app-shell:has(.chat-view.is-revealing.stages-notice:not(.holds-notice)) .ai-disclosure { animation: cv-reveal-in var(--reveal-notice) ease-in-out; }\n@keyframes cv-reveal-in {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n/* The caret lands in the box still; its four blinks wait for the rest. */\n.chat-view.is-revealing .cv-static-caret.is-welcome { animation: none; }\n/* The page listens for a tap while it plays (ChatView): no grey flash on an\n   iPhone. */\n.chat-view.is-revealing { -webkit-tap-highlight-color: transparent; }\n\n/* Ask's glimmer, once, in the first view (ChatView REVEAL): two soft sweeps,\n   the starters' glimmer made for a button. A faint band of light crosses the\n   quiet Ask, and its word and edge brighten to the text colour as it passes.\n   Monochrome, like everything else: on Day's white box the band would be\n   lost, so there it is the word and the edge alone. Never with reduced\n   motion (the first view isn't staged then either). */\n.chat-view.is-glimmering .cv-icon-btn.send {\n  position: relative;\n  isolation: isolate;\n  animation: cv-ask-glint var(--reveal-glimmer) cubic-bezier(0.45, 0, 0.2, 1) 2;\n}\n.chat-view.is-glimmering .cv-icon-btn.send::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  z-index: -1;\n  border-radius: inherit;\n  pointer-events: none;\n  background: linear-gradient(105deg, transparent 25%, var(--cv-ask-sheen, color-mix(in srgb, var(--brand-fg) 18%, transparent)) 50%, transparent 75%) no-repeat;\n  background-size: 70% 100%;\n  background-position: -120% 0;\n  opacity: 0;\n  animation: cv-ask-sheen var(--reveal-glimmer) cubic-bezier(0.45, 0, 0.2, 1) 2;\n}\n:root[data-theme=\"day\"] { --cv-ask-sheen: transparent; }\n@keyframes cv-ask-glint {\n  0%, 100% { color: var(--brand-muted); border-color: var(--brand-line-control); }\n  45%, 60% { color: var(--brand-fg); border-color: var(--brand-fg); }\n}\n@keyframes cv-ask-sheen {\n  0% { opacity: 0; background-position: -120% 0; }\n  20% { opacity: 1; }\n  80% { opacity: 1; }\n  100% { opacity: 0; background-position: 220% 0; }\n}\n@media (prefers-reduced-motion: reduce) {\n  .chat-view.is-glimmering .cv-icon-btn.send,\n  .chat-view.is-glimmering .cv-icon-btn.send::before { animation: none !important; }\n}\n\n/* A statement or your-turn landing: the ad's words, then the box. */\n.cv-landing {\n  margin: 4px 0 24px;\n}\n\n/* ---- support (utils/giving.js) --------------------------------------------- */\n\n/* Every third question: one muted line under the answer, with no box,\n   never louder than the answer itself. */\n.cv-support {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin: 0 0 18px 2px;\n  max-width: var(--measure);\n  font-size: 0.8125rem;\n  line-height: 1.5;\n  color: var(--brand-muted);\n}\n\n.cv-support .apr-icon {\n  margin-top: 2px;\n  color: var(--brand-subtle);\n}\n\n.cv-support a {\n  color: inherit;\n}\n\n.cv-support a:hover {\n  color: var(--brand-fg);\n}\n\n.cv-msg.streaming .cv-support { margin-top: 14px; }\n.cv-answer-meta + .cv-support { margin-top: -6px; }\n\n/* The 988 line: where the support line would stand on the cards in the box's\n   place, and under the questions-left line, in a conversation that had a\n   crisis card. As quiet as the support line; the number is a real link. */\n.cv-crisis-line {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin: 0 2px 8px;\n  max-width: var(--measure);\n  font-size: 0.8125rem;\n  line-height: 1.5;\n  color: var(--brand-muted);\n}\n\n.cv-crisis-line .apr-icon {\n  margin-top: 2px;\n  color: var(--brand-subtle);\n}\n\n.cv-crisis-line a {\n  color: var(--brand-fg);\n  font-weight: 600;\n}\n\n/* ---- cards in the conversation: the account nudge, giving ---------------- */\n\n.cv-card {\n  margin: 4px 0 26px;\n  padding: 16px 18px;\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--brand-line);\n  background: var(--brand-surface);\n  max-width: var(--measure);\n}\n\n.cv-card p {\n  margin: 0;\n  font-size: 0.9375rem;\n  line-height: 1.55;\n  color: var(--brand-fg-read);\n}\n\n.cv-card strong { color: var(--brand-fg); font-weight: 600; }\n\n.cv-card-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px 12px;\n  margin-top: 14px;\n}\n\n/* ---- the real Rob, and the next-step ladder (§11.1) ----------------------- */\n\n.cv-rob {\n  margin: 4px 0 6px;\n}\n\n.cv-rob-media {\n  position: relative;\n  margin-top: 8px;\n  aspect-ratio: 16 / 9;\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  background: var(--brand-surface-2);\n}\n\n.cv-rob-media video,\n.cv-rob-play img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: 50% 18%;\n}\n\n.cv-rob-play {\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 100%;\n  padding: 0;\n}\n\n.cv-rob-play-ring {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  display: grid;\n  place-items: center;\n  width: 56px;\n  height: 56px;\n  margin: -28px 0 0 -28px;\n  border-radius: 50%;\n  border: 2px solid #fff;\n  background: rgba(0, 0, 0, 0.72);\n  color: #fff;\n}\n\n.cv-rob-placeholder {\n  position: absolute;\n  left: 10px;\n  top: 10px;\n  padding: 4px 6px;\n  font-size: 0.6875rem;\n  font-weight: 600;\n  background: #000;\n  color: #fff;\n  outline: 1px solid var(--brand-danger);\n}\n\n.cv-rob-meta {\n  margin-top: 8px;\n  font-size: 0.8125rem;\n  line-height: 1.4;\n  color: var(--brand-muted);\n}\n\n.cv-ladder {\n  margin: 22px 0 28px;\n  max-width: var(--measure);\n}\n\n.cv-step + .cv-step { margin-top: 14px; }\n.cv-ladder .cv-label + .cv-step { margin-top: 10px; }\n\n.cv-step-desc {\n  margin: 6px 2px 0;\n  font-size: 0.875rem;\n  line-height: 1.4;\n  color: var(--brand-muted);\n}\n\n/* ---- \"Ask the real Rob\" ---------------------------------------------------- */\n\n.askrob-panel {\n  margin: 0 0 20px;\n  padding: 18px;\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--brand-line-control);\n  background: var(--brand-surface);\n  max-width: var(--measure);\n}\n\n.askrob-title {\n  margin: 0;\n  font-size: 1.0625rem;\n  line-height: 1.35;\n  font-weight: 600;\n  color: var(--brand-fg);\n}\n\n.askrob-head p {\n  margin: 6px 0 0;\n  font-size: 0.9375rem;\n  line-height: 1.5;\n  color: var(--brand-fg-read);\n}\n\n.askrob-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n  margin-top: 16px;\n}\n\n.askrob-grid label {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: var(--brand-muted);\n}\n\n.askrob-grid label em { font-style: normal; font-weight: 500; color: var(--brand-subtle); }\n.askrob-wide { grid-column: 1 / -1; }\n.chat-view .askrob-grid textarea { min-height: 84px; resize: vertical; }\n\n.askrob-actions {\n  display: flex;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 16px;\n}\n\n.askrob-error { margin-top: 12px; }\n\n.askrob-sent {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin: 0;\n  font-size: 0.9375rem;\n  line-height: 1.5;\n  color: var(--brand-fg-read);\n}\n\n.askrob-sent strong { color: var(--brand-fg); }\n.askrob-sent .apr-icon { margin-top: 2px; }\n/* The 988 line, always in the panel; the safe-way line when abuse came up. */\n.askrob-988,\n.askrob-safe {\n  margin: 10px 0 0;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  color: var(--brand-fg-read);\n}\n.askrob-safe { color: var(--brand-fg); }\n.askrob-card { margin: 0 0 12px; }\n\n/* ---- jump to the latest ---------------------------------------------------- */\n\n.cv-jump {\n  position: absolute;\n  right: 16px;\n  bottom: 12px;\n  z-index: 3;\n  display: grid;\n  place-items: center;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  border: 1px solid var(--brand-line-control);\n  background: var(--brand-surface);\n  color: var(--brand-fg);\n}\n\n.cv-jump:hover { background: var(--brand-surface-2); }\n\n/* ---- bars docked above the composer: AI Rob's voice, the human door ------- */\n\n.cv-voice-bar,\n.cv-door {\n  flex: none;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-height: 48px;\n  padding: 0 max(20px, calc((100% - var(--column-chat)) / 2));\n  background: var(--brand-surface);\n  border-top: 1px solid var(--brand-line);\n}\n\n.cv-voice-bar {\n  flex-wrap: wrap;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  gap: 8px 12px;\n}\n\n.cv-voice-label {\n  flex: 1 1 12em;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--brand-fg-read);\n}\n\n/* The team's line: which voice is reading, and why Grok read when ElevenLabs was picked. */\n.cv-voice-who { color: var(--brand-fg); font-weight: 600; white-space: nowrap; }\n\n.cv-voice-note {\n  display: block;\n  margin-top: 2px;\n  font-size: 0.8125rem;\n  font-weight: 400;\n  line-height: 1.4;\n  color: var(--brand-muted);\n}\n\n.cv-voice-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.cv-voice-stop {\n  min-height: 44px;\n  padding: 0 14px;\n  font-size: 0.9375rem;\n}\n\n.cv-voice-type { font-size: 0.9375rem; }\n\n.cv-door {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--brand-fg-read);\n}\n\n.cv-door > .apr-icon { color: var(--brand-muted); }\n\n.cv-door-text {\n  flex: 1;\n  min-width: 0;\n}\n\n.cv-door-btn {\n  flex: none;\n  min-height: 44px;\n  padding: 0 2px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--brand-fg);\n  text-decoration-line: underline;\n  text-decoration-thickness: 1px;\n  text-underline-offset: 0.2em;\n}\n\n.cv-door-btn:hover { text-decoration-thickness: 2px; }\n\n/* ---- the composer (§11.1) -------------------------------------------------- */\n\n.cv-composer {\n  flex-shrink: 0;\n  padding: 10px 0 calc(6px + env(safe-area-inset-bottom, 0px));\n  background: var(--brand-bg);\n}\n\n/* A card in the box's place (the email gate, the window's limit) or the\n   email form above the box can outgrow a small phone: the conversation\n   keeps a glimpse of the question, and the card scrolls instead of being\n   cut off. */\n.chat-view.has-card .cv-composer {\n  flex-shrink: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n}\n\n.chat-view.has-card .cv-messages-wrap { min-height: 72px; }\n\n.cv-form { display: flex; flex-direction: column; }\n\n/* ---- \"Ask about this\" (utils/quote.js) ---------------------------------------\n\n   Words selected in a finished answer offer \"Ask about this\" at the top of\n   the composer, never over the words; a tap puts them in a quote above the\n   box, and the turn shows them above the person's own words. A quote is AI\n   Rob's words, so it is set in the sans (§6.2), italic at Alexi's request\n   (Oct 2026: BRAND_SPEC §6.5's exception), between curly quotes and beside a\n   thin rule. Its italic is a real one (public/fonts/inter-italic-latin.woff2,\n   fetched only when one is on screen), never one the browser fakes:\n   --quote-style: normal sets every quote upright again. Text and label are\n   7:1 or better in Night and Day. */\n\n.cv-ask-offer-row {\n  display: flex;\n  margin: 0 0 8px;\n}\n\n.cv-ask-offer {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 44px;\n  padding: 0 16px 0 14px;\n  border-radius: 22px;\n  border: 1px solid var(--brand-line-control);\n  background: var(--brand-surface);\n  color: var(--brand-fg);\n  font-size: 0.9375rem;\n  font-weight: 600;\n  line-height: 1.2;\n  animation: cv-ask-in var(--dur-fast) var(--ease-out);\n}\n\n.cv-ask-offer .apr-icon { flex: none; color: var(--brand-muted); }\n.cv-ask-offer:hover { background: var(--brand-surface-2); }\n\n@keyframes cv-ask-in {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.cv-quote-chip {\n  display: flex;\n  align-items: flex-start;\n  gap: 4px;\n  margin: 0 0 8px;\n  padding: 10px 0 10px 14px;\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--brand-line-control);\n  background: var(--brand-surface);\n}\n\n.cv-quote {\n  min-width: 0;\n  margin: 0;\n  padding: 1px 0 1px 12px;\n  border-left: 2px solid var(--brand-line-control);\n}\n\n.cv-quote.is-chip { flex: 1 1 auto; }\n.cv-quote.is-turn { margin: 8px 0 0; }\n\n/* The quote follows the question in the page (ChatParts UserTurn: a screen\n   reader jumping to the heading hears what \"this\" is next) and shows above\n   it: \"You\", the quote, then their words. A flex column keeps the gaps the\n   block layout had (8 px each; margins don't collapse here). */\n.cv-msg.user.quoting { display: flex; flex-direction: column; }\n.cv-msg.user.quoting > .cv-label { order: -2; }\n.cv-msg.user.quoting > .cv-quote.is-turn { order: -1; }\n\n.cv-quote-label {\n  display: block;\n  font-size: 0.8125rem;\n  line-height: 1.35;\n  font-weight: 500;\n  color: var(--brand-muted);\n}\n\n.cv-quote-text {\n  display: block;\n  margin: 2px 0 0;\n  font-family: var(--font-sans);\n  font-style: var(--quote-style, italic);\n  font-synthesis: none;\n  font-weight: 400;\n  font-size: 1rem;\n  line-height: 1.5;\n  color: var(--brand-fg-read);\n  white-space: pre-line;\n  overflow-wrap: anywhere;\n  quotes: \"“\" \"”\" \"‘\" \"’\";\n}\n\n.cv-quote-text::before { content: open-quote; }\n.cv-quote-text::after { content: close-quote; }\n\n/* Above the box: two lines at most, then an ellipsis. */\n.cv-quote.is-chip .cv-quote-text {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  overflow: hidden;\n  font-size: 0.9375rem;\n  line-height: 1.45;\n}\n\n.cv-quote-remove {\n  flex: none;\n  display: grid;\n  place-items: center;\n  width: 44px;\n  height: 44px;\n  margin: -6px 0 -6px 0;\n  border-radius: 50%;\n  color: var(--brand-muted);\n}\n\n.cv-quote-remove:hover { background: var(--brand-surface-2); color: var(--brand-fg); }\n\n/* A short screen (a small phone with its keyboard up) keeps the conversation\n   in sight: one line of the quote. */\n@media (max-height: 600px) {\n  .cv-quote.is-chip .cv-quote-text { -webkit-line-clamp: 1; line-clamp: 1; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .cv-ask-offer { animation: none; }\n}\n\n.cv-quota {\n  margin: 0 2px 8px;\n  font-size: 0.8125rem;\n  font-weight: 500;\n  color: var(--brand-muted);\n}\n\n.cv-link {\n  padding: 0;\n  font: inherit;\n  color: var(--brand-fg);\n  text-decoration: underline;\n  text-underline-offset: 0.2em;\n}\n\n.cv-input-row {\n  --cv-row-pad: 3px;\n  position: relative;\n  display: flex;\n  align-items: flex-end;\n  gap: 8px;\n  min-height: 52px;\n  padding: var(--cv-row-pad) var(--cv-row-pad) var(--cv-row-pad) 16px;\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--brand-line-control);\n  background: var(--brand-surface);\n  cursor: text;\n}\n\n.cv-input-row:focus-within {\n  border-color: var(--brand-fg);\n  box-shadow: inset 0 0 0 1px var(--brand-fg);\n}\n\n.chat-view .cv-input {\n  flex: 1;\n  min-width: 0;\n  min-height: 44px;\n  max-height: 160px;\n  padding: 10px 0;\n  background: transparent;\n  border: 0;\n  border-radius: 0;\n  box-shadow: none;\n  color: var(--brand-fg);\n  font-size: 1.0625rem; /* 16 px or more stops iOS zooming */\n  line-height: 1.4;\n  resize: none;\n  outline: none;\n  caret-color: var(--brand-caret);\n}\n\n.chat-view .cv-input:focus { outline: none; box-shadow: none; border: 0; }\n\n/* The placeholder says what to do, in the muted grey rather than the subtle\n   one (8.5:1 on Night, 8.4:1 on Day): plainly readable, still unlike words\n   someone has typed. */\n.chat-view .cv-input::placeholder {\n  color: var(--brand-muted);\n  /* In Newsreader italic (Alexi, Oct 17): the serif is a person's words, and\n     the slant says \"your words go here\" (public/fonts/newsreader-italic-latin.woff2). */\n  font-family: var(--font-serif);\n  font-style: italic;\n  /* One line, always: on the narrowest phones a wrapped placeholder was\n     clipped mid-word by the one-row box. */\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.chat-view .cv-input:disabled { opacity: 1; color: var(--brand-fg); }\n\n/* The front page's box for a first question (.first-turn: the welcome, a\n   statement or your-turn landing), for someone who has never typed to a\n   website before (Alexi, Oct 2026: clear to an 84-year-old): a 2 px edge in\n   the muted grey (9.4:1 on Night's black, 7.5:1 on Day's cream), and its\n   words, placeholder and \"Ask\" a size up, 20 px. Focused, the edge turns\n   white (black on Day) and the focus ring goes round it (§11.0 Inputs).\n   Once a conversation is under way the box is the compact one again, with\n   its 1 px control edge. */\n.chat-view.first-turn .cv-input-row {\n  --cv-row-pad: 2px;\n  border: 2px solid var(--brand-muted);\n}\n.chat-view.first-turn .cv-input-row:focus-within { border-color: var(--brand-fg); box-shadow: none; }\n.chat-view.first-turn .cv-input-row:has(.cv-input:focus) {\n  box-shadow: 0 0 0 2px var(--brand-focus-offset), 0 0 0 4px var(--brand-focus);\n}\n.chat-view.first-turn .cv-input,\n.chat-view.first-turn .cv-static-caret,\n.chat-view.first-turn .cv-icon-btn.cv-word { font-size: 1.25rem; }\n.chat-view.first-turn .cv-voice-level { right: 140px; } /* clear of the mic and the wider Ask */\n/* On a phone its words get the whole width of the box, and the mic and Ask\n   sit on a row under them, at its two ends (a slip off Ask never starts the\n   mic), so \"Type your question here\" is never cut short, even at 320 px. */\n@media (max-width: 480px) {\n  .chat-view.first-turn .cv-input-row {\n    flex-wrap: wrap;\n    justify-content: flex-end;\n    row-gap: 0;\n    container-type: inline-size; /* for the zoomed-in rule just below */\n  }\n  .chat-view.first-turn .cv-input { flex: 1 0 100%; padding: 10px 14px 6px 0; }\n  .chat-view.first-turn .cv-icon-btn.mic { margin-right: auto; }\n  .chat-view.first-turn .cv-voice-level { right: 16px; bottom: 48px; }\n  /* Zoomed in, or with large text (a 390 px iPhone at 150 %, an Android\n     phone with its text enlarged), the placeholder can't fit on one line:\n     it wraps, and the empty box has room for both lines. In rem, so larger\n     text needs a wider box before it comes back to one line. */\n  @container (max-width: 16rem) {\n    .chat-view.first-turn .cv-input::placeholder { white-space: normal; }\n    .chat-view.first-turn .cv-input:placeholder-shown { min-height: calc(2.8em + 16px); }\n  }\n}\n/* The narrowest phones: a pixel smaller. */\n@media (max-width: 340px) {\n  .chat-view.first-turn .cv-input,\n  .chat-view.first-turn .cv-static-caret,\n  .chat-view.first-turn .cv-icon-btn.cv-word { font-size: 1.1875rem; }\n}\n\n/* The box's caret before anyone types (decorative, aria-hidden): the brand\n   caret's shape (§4) in ems of the box's words, hanging below their\n   baseline, just before where they start, so the placeholder never moves.\n   Still on a statement landing (§11.1). On the default welcome it comes once\n   \"Ask anything.\" has typed, blinks four times (4,240 ms, §9.2: WCAG 2.2.2)\n   and then stays. It steps aside (.is-aside) while the box has focus or\n   words, so there is one live caret: the box's own takes over where the\n   words start, about 4 px to its right (the gap keeps this one clear of the\n   placeholder's first letter). */\n.cv-static-caret {\n  position: absolute;\n  left: 11px;\n  top: calc(var(--cv-row-pad) + 10px + 0.28em);\n  width: max(2px, var(--caret-width));\n  height: var(--caret-height);\n  font-size: 1.0625rem; /* the box's words */\n  background: var(--brand-caret);\n  pointer-events: none;\n}\n.cv-static-caret.is-aside { visibility: hidden; }\n.cv-static-caret.is-welcome {\n  animation: cv-caret-blink calc(var(--caret-on) + var(--caret-off)) steps(1, end) 4;\n}\n@keyframes cv-caret-blink {\n  0% { opacity: 1; }\n  50% { opacity: 0; }\n}\n@media (prefers-reduced-motion: reduce) {\n  .cv-static-caret.is-welcome { animation: none; }\n}\n/* High-contrast modes would paint it the box's own colour: the text colour. */\n@media (forced-colors: active) {\n  .cv-static-caret { forced-color-adjust: none; background: CanvasText; }\n}\n\n.cv-icon-btn {\n  flex-shrink: 0;\n  display: grid;\n  place-items: center;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  border: 1px solid var(--brand-line-control);\n  background: transparent;\n  color: var(--brand-muted);\n}\n\n.cv-icon-btn:hover:not(:disabled) { background: var(--brand-surface-2); color: var(--brand-fg); }\n.cv-icon-btn:disabled { cursor: default; color: var(--brand-line-control); }\n\n/* The live action has the 2 px line: Ask once there is a question (or the\n   mic is listening), Stop while answering, the mic while it records. */\n.cv-icon-btn.send:not(:disabled):not([aria-disabled=\"true\"]),\n.cv-icon-btn.send.stop,\n.cv-icon-btn.mic.recording {\n  border: 2px solid var(--brand-fg);\n  color: var(--brand-fg);\n}\n\n/* Ask, once there's a question to ask, fills (Alexi, Oct 17: \"a soft\n   highlight on the send\"): solid white with black words on Night, black with\n   cream on Day, so it is plainly the thing to press. It eases in once, the\n   moment the first letter lands; no glow (§5), and no easing with reduced\n   motion. Stop keeps the 2 px line only. */\n.cv-icon-btn.send:not(.stop):not(:disabled):not([aria-disabled=\"true\"]) {\n  background: var(--brand-fg);\n  color: var(--brand-bg);\n}\n.cv-icon-btn.send { transition: background-color 0.45s ease, color 0.45s ease; }\n@media (prefers-reduced-motion: reduce) {\n  .cv-icon-btn.send { transition: none; }\n}\n\n/* \"Ask\" and \"Stop\", in words: a pill beside the round mic, 44 px tall, 17 px\n   type (20 px in the first question's box), the words someone reads to act.\n   The same width whichever it says, quiet (the 1 px control edge, the muted\n   grey, still easy to read) or live (2 px): the mic beside it never moves. */\n.cv-icon-btn.cv-word {\n  width: auto;\n  min-width: 4em;\n  padding: 0 0.75em;\n  border-radius: 22px;\n  font-size: 1.0625rem;\n  font-weight: 600;\n  line-height: 1;\n}\n.cv-icon-btn.cv-word[aria-disabled=\"true\"] { color: var(--brand-muted); }\n\n.cv-icon-btn.mic.busy { cursor: wait; }\n\n/* One 2 px white line shows the voice level while recording (§11.1). */\n.cv-voice-level {\n  position: absolute;\n  left: 16px;\n  right: 128px; /* clear of the mic and Ask */\n  bottom: 6px;\n  height: 2px;\n  pointer-events: none;\n}\n\n.cv-voice-level > span {\n  display: block;\n  height: 2px;\n  background: var(--brand-fg);\n  transform-origin: left center;\n  transform: scaleX(0.06);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .cv-voice-level > span { transform: none; opacity: 0.6; }\n}\n\n/* Everything under the input row except the fine print sits in one\n   collapsible grid row so phones can fold it away while reading. The\n   1fr -> 0fr transition animates to the content's real height. */\n.cv-chrome {\n  display: grid;\n  grid-template-rows: 1fr;\n  transition: grid-template-rows var(--dur-base) var(--ease-out), opacity var(--dur-fast) var(--ease-out);\n}\n\n.cv-chrome-inner {\n  min-height: 0;\n  overflow: hidden;\n  /* room for the focus ring, which the clip would otherwise cut */\n  margin: 0 -6px;\n  padding: 0 6px;\n  transition: visibility 0s;\n}\n\n/* Compact composer (phones in either orientation; ChatView only sets the\n   class when its COMPACT_QUERY matches): after 5 s idle or a scroll down the\n   toolbar fades and folds, and the box drops toward the bottom edge.\n   Focusing or typing unfolds it. visibility waits for the fold so the\n   buttons stay visible while they fade, then leave the tab order. */\n.cv-composer.collapsed .cv-chrome { grid-template-rows: 0fr; opacity: 0; }\n.cv-composer.collapsed .cv-chrome-inner { visibility: hidden; transition-delay: var(--dur-base); }\n\n.cv-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 0 2px;\n}\n\n/* Fast / Deeper: a segmented choice. Selected = a 2 px white edge and a\n   check, never a fill (§11.0). */\n.cv-tier {\n  display: inline-flex;\n}\n\n.cv-tier-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-height: 44px;\n  padding: 0 14px;\n  border: 1px solid var(--brand-line-control);\n  background: transparent;\n  color: var(--brand-muted);\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\n.cv-tier-btn:first-child { border-radius: var(--radius-md) 0 0 var(--radius-md); }\n.cv-tier-btn:last-child { border-radius: 0 var(--radius-md) var(--radius-md) 0; margin-left: -1px; }\n.cv-tier-btn:hover { color: var(--brand-fg); }\n\n.cv-tier-btn.on {\n  position: relative;\n  z-index: 1;\n  border-color: var(--brand-fg);\n  box-shadow: inset 0 0 0 1px var(--brand-fg);\n  color: var(--brand-fg);\n}\n\n.cv-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 44px;\n  padding: 0 12px;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--brand-line-control);\n  background: transparent;\n  color: var(--brand-fg);\n  font-size: 0.875rem;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\nbutton.cv-pill:hover:not(:disabled) { background: var(--brand-surface-2); }\n.cv-pill.saved { color: var(--brand-muted); border-color: var(--brand-line); }\n.cv-pill.voice { color: var(--brand-muted); }\n.cv-pill.voice.on { color: var(--brand-fg); }\n.cv-pill:disabled { color: var(--brand-line-control); }\n\n.cv-pill .apr-switch-track {\n  width: 34px;\n  height: 20px;\n}\n\n.cv-pill .apr-switch-track::after {\n  width: 12px;\n  height: 12px;\n}\n\n.cv-pill[aria-checked=\"true\"] > .apr-switch-track::after {\n  transform: translateX(14px);\n}\n\n/* The fine print stays under the box (§11.1). Only a landscape phone, where\n   every line of reading room counts, folds it with the toolbar while reading;\n   it comes back with the toolbar. */\n.cv-disclaimer {\n  margin: 8px 2px 2px;\n  font-size: 0.8125rem;\n  line-height: 1.4;\n  color: var(--brand-subtle);\n}\n.cv-disclaimer-line { display: block; }\n.cv-disclaimer a { color: inherit; text-decoration: underline; text-underline-offset: 2px; }\n\n@media (max-height: 500px) {\n  .cv-composer.collapsed .cv-disclaimer {\n    display: none;\n  }\n}\n\n/* ---- the window's limit, and the email gate (§11.1) ------------------------ */\n\n.cv-limit {\n  padding: 18px;\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--brand-line-control);\n  background: var(--brand-surface);\n}\n\n.cv-limit-title {\n  margin: 0;\n  font-size: 1.0625rem;\n  line-height: 1.35;\n  font-weight: 600;\n  color: var(--brand-fg);\n}\n\n.cv-limit-text {\n  margin: 4px 0 0;\n  font-size: 0.9375rem;\n  line-height: 1.5;\n  color: var(--brand-fg-read);\n}\n\n.cv-limit .cv-support,\n.cv-limit .cv-crisis-line { margin: 12px 0 0; }\n\n/* \"Want to keep going?\": the email form under the card's words. */\n.cv-gate .email-signup { margin-top: 14px; }\n\n.cv-gate-later {\n  margin: 2px 0 0;\n  font-size: 0.875rem;\n  line-height: 1.45;\n  color: var(--brand-muted);\n}\n\n/* The email form opened from the questions-left line. */\n.cv-quota-join {\n  margin: 0 0 10px;\n  padding: 14px 16px;\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--brand-line-control);\n  background: var(--brand-surface);\n}\n\n/* \"Thanks! You're in.\": a moment above the box, then gone. */\n.cv-joined {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 2px 8px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--brand-fg-read);\n}\n\n.cv-limit-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px;\n  margin-top: 16px;\n}\n\n/* ---- Focused Study headers -------------------------------------------------- */\n\n.cv-header {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-height: 60px;\n  padding: 8px max(20px, calc((100% - var(--column-chat)) / 2));\n  border-bottom: 1px solid var(--brand-line);\n  background: var(--brand-bg);\n}\n\n.cv-header-title { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 1px; }\n\n.cv-header-title h2 {\n  margin: 0;\n  font-family: var(--font-sans);\n  font-size: 1rem;\n  line-height: 1.3;\n  font-weight: 600;\n  color: var(--brand-fg);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.cv-header-sub {\n  font-size: 0.8125rem;\n  line-height: 1.4;\n  color: var(--brand-muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.cv-header-sub a { color: var(--brand-fg); }\n\n.cv-back {\n  flex: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-height: 44px;\n  padding: 0 12px 0 8px;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--brand-line-control);\n  color: var(--brand-fg);\n  font-size: 0.9375rem;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.cv-back:hover { background: var(--brand-surface-2); }\n.cv-header-right { display: flex; align-items: center; gap: 8px; }\n\n/* The sermon list (several sermons) */\n.cv-sermons { position: relative; }\n\n.cv-sermons-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-height: 44px;\n  padding: 0 12px;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--brand-line-control);\n  color: var(--brand-fg);\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\n.cv-sermons-btn:hover { background: var(--brand-surface-2); }\n.cv-sermons-btn[aria-expanded=\"true\"] .cv-sermons-chevron { transform: rotate(180deg); }\n\n.cv-sermons-list {\n  position: absolute;\n  top: calc(100% + 6px);\n  /* The button sits at the right end of the header: open leftward, so the\n     list stays on screen on a phone instead of running off its right edge. */\n  right: 0;\n  z-index: 20;\n  width: min(420px, 86vw);\n  max-height: 320px;\n  overflow-y: auto;\n  padding: 6px;\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--brand-line-control);\n  background: var(--brand-surface);\n}\n\n.cv-sermons-item {\n  display: flex;\n  gap: 10px;\n  align-items: baseline;\n  min-height: 44px;\n  padding: 10px;\n  border-radius: var(--radius-md);\n  font-size: 0.9375rem;\n  line-height: 1.35;\n  color: var(--brand-fg);\n  text-decoration: none;\n}\n\n.cv-sermons-item:hover { background: var(--brand-surface-2); text-decoration: none; }\n.cv-sermons-item .n { min-width: 20px; color: var(--brand-muted); font-weight: 600; font-variant-numeric: tabular-nums; }\n.cv-sermons-item .d { margin-left: auto; white-space: nowrap; font-size: 0.8125rem; color: var(--brand-muted); }\n\n.cv-context { display: inline-flex; align-items: center; gap: 6px; font-size: 0.8125rem; color: var(--brand-muted); white-space: nowrap; font-variant-numeric: tabular-nums; }\n.cv-context-bar { width: 64px; height: 6px; border-radius: 3px; border: 1px solid var(--brand-line-control); overflow: hidden; }\n.cv-context-fill { height: 100%; background: var(--brand-fg); }\n\n/* ---- smaller screens -------------------------------------------------------- */\n\n@media (max-width: 720px) {\n  .cv-scroll { padding-top: 16px; }\n  .askrob-grid { grid-template-columns: 1fr 1fr; }\n  .cv-welcome { margin-top: 4vh; }\n  .cv-header-right .cv-context { display: none; }\n  .cv-jump { right: 12px; bottom: 10px; }\n  .cv-limit-actions { flex-direction: column; align-items: stretch; }\n  .cv-limit-actions .apr-btn { width: 100%; }\n  .askrob-actions .apr-btn { flex: 1 1 auto; }\n}\n\n@media (max-width: 420px) {\n  .askrob-grid { grid-template-columns: 1fr; }\n  .cv-tier-btn { padding: 0 12px; }\n  .cv-action { padding: 0 10px; }\n}\n\n/* The smallest phones: \"Sermons\" folds into the arrow so the study title can\n   be read, and the placeholder steps down to fit the box (only the input's\n   own size matters to iOS zoom, not its placeholder's). */\n@media (max-width: 360px) {\n  .cv-back-label { display: none; }\n  .cv-back { padding: 0 10px; }\n  .cv-header { gap: 8px; padding-left: 16px; padding-right: 16px; }\n  .cv-sermons-btn { padding: 0 10px; }\n  .chat-view:not(.first-turn) .cv-input::placeholder { font-size: 15px; }\n  .cv-question.size-lead { font-size: 1.75rem; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .cv-msg.user.landing > *,\n  .cv-fresh { animation: none; }\n  .cv-chrome,\n  .cv-chrome-inner,\n  .cv-header-slot,\n  .chat-view.tucked .cv-header-slot { transition: none; }\n}\n\n/* Two short lines on a phone: the fine print steps down a notch so neither wraps. */\n@media (max-width: 430px) {\n  .cv-disclaimer { font-size: 0.75rem; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
